export const finnishTranslation = {
  'Les lignes de commandes ont été mises à jour avec succès !':
    'Komentorivit on päivitetty onnistuneesti!',
  'La traduction a été enregistrée avec succès':
    'Käännös tallennettiin onnistuneesti',
  'Texte + Traduction enregistré avec succès':
    'Teksti + Käännös tallennettiin onnistuneesti',
  'Nombre de mots': 'Sanojen määrä',
  Lingala: 'Lingala',
  'Prénom/Nom du client': 'Asiakkaan etunimi/sukunimi',
  Bashkir: 'Bashkir',
  "La date doit être ultérieure à aujourd'hui.":
    'Päivämäärän on oltava myöhemmin kuin tänään.',
  'Contenu rédigé': 'Kirjoitettu sisältö',
  'Nom/prénom': 'Sukunimi / etunimi',
  'Mot de passe incorrect': 'Virheellinen salasana',
  Institutions: 'Toimielimet',
  'Veuillez donner un descriptif au document téléchargé':
    'Anna kuvaus ladatusta asiakirjasta',
  'Sichuan Yi ; Nuosu': 'Sichuan Yi; Nuosu',
  Suivant: 'Seuraava',
  Kannada: 'Kannada',
  'Séparer les mots clés par un "enter"': 'Erottele avainsanat "enterillä".',
  Allemand: 'Saksan',
  Sango: 'Sango',
  'Min.': 'Min.',
  'un email contenant un lien de réinitialisation du mot de passe a été envoyé à votre email':
    'sähköpostiisi on lähetetty salasanan palautuslinkin sisältävä sähköpostiviesti.',
  'Chef edito': 'Päätoimittaja',
  Croate: 'Kroatian',
  'Nb de textes': 'Tekstien lukumäärä',
  Violet: 'Violetti',
  'Ce champs doit être sup ou égale nombre de texte':
    'Tämän kentän on oltava suurempi tai yhtä suuri kuin tekstin määrä.',
  'a été activé avec succès': 'on onnistuneesti aktivoitu',
  Népalais: 'Nepalilainen',
  'Nombre de FAQ': 'Useiden usein kysyttyjen kysymysten määrä',
  Urdu: 'Urdu',
  'Analyses restantes': 'Jäljellä olevat analyysit',
  Indonésien: 'Indonesialainen',
  Breton: 'Breton',
  Livrés: 'Toimitettu',
  Associations: 'Yhdistykset',
  'Le client': 'Asiakas',
  'Révision demandée': 'Pyydetty tarkistus',
  "Une erreur s'est produite, veuillez réessayer":
    'On tapahtunut virhe, yritä uudelleen',
  'Mise à jour non autorisée car des textes ont été livrés':
    'Luvaton päivitys, koska tekstit on toimitettu.',
  "Pour ajouter un texte (optimisation d'un contenu existant)":
    'Tekstin lisääminen (olemassa olevan sisällön optimointi)',
  Gaélique: 'Gaelic',
  'La ligne de commande pour': 'Komentorivi',
  'Business/Management': 'Liiketoiminta/johtaminen',
  Serbe: 'Serbian',
  "Merci d'indiquer ci-dessous vos demandes de modifications en prenant bien en compte nos conditions de repasses":
    'Ilmoittakaa alla muutospyyntönne ottaen huomioon silitysehdot.',
  'rédacteurs trouvés': 'löytyi kirjailijoita',
  'Kirghiz ; Kirghiz': 'Kirgis; Kirgis',
  Différence: 'Ero',
  'en cours': 'käynnissä',
  'Sami du Nord': 'Pohjoissaame',
  Comparer: 'Vertaa',
  Lituanien: 'Liettuan',
  'Typix - Mon tableau de bord': 'Typix - Oma kojelauta',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial et ne pas être identique au nom':
    'Vähintään 8 merkkiä, jossa on oltava iso kirjain, numero tai erikoismerkki ja joka ei saa olla sama kuin nimi.',
  Webmaster: 'Verkkomestari',
  'Veuillez saisir des champs valides': 'Syötä kelvolliset kentät',
  Basque: 'Baskimaan',
  'Exporter .csv': 'Vie .csv',
  'Confirmer le nouveau mot de passe': 'Vahvista uusi salasana',
  "Pas d'options": 'Ei vaihtoehtoja',
  'Banque/Assurance': 'Pankkitoiminta/Vakuutus',
  'Vos demandes': 'Pyyntönne',
  'Coût d\u2019achat': 'Hankintakustannukset',
  Tamil: 'Tamil',
  'Le texte a été supprimé avec succès': 'Teksti poistettiin onnistuneesti',
  'Mes Commandes': 'Tilaukseni',
  Zoulou: 'Zulu',
  Afficher: 'Näytä',
  Texte: 'Teksti',
  Islandais: 'Islantilainen',
  Russe: 'Venäläinen',
  'Tous les textes': 'Kaikki tekstit',
  Czech: 'Tšekki',
  'Comparaison hors ligne': 'Offline-vertailu',
  Téléphonie: 'Puhelinpalvelut',
  'Valider le texte': 'Vahvista teksti',
  'Votre text ne de doit pas dépasser 500 mots':
    'Tekstisi ei saisi ylittää 500 sanaa',
  'Coquilles (double espace, « s »\u2026)':
    'Kuoret (kaksoisvälilyönti, "s"...)',
  'le consultant': 'konsultti',
  Coréen: 'Korean',
  'Nb de Silo': 'Siilojen lukumäärä',
  Validés: 'Validoitu',
  'non attribuées': 'jakamaton',
  Néerlandais: 'Hollantilainen',
  'Voulez-vous vraiment supprimer': 'Haluatko todella poistaa',
  Rundi: 'Rundi',
  Regional: 'Alueellinen',
  'Compte client': 'Asiakastili',
  Global: 'Maailmanlaajuinen',
  'Tous les rôles': 'Kaikki roolit',
  Musique: 'Musiikki',
  Perso: 'Henkilökohtainen',
  Kinyarwanda: 'Kinyarwanda',
  'Il semblerait que tu n\u2019aies plus de crédit d\u2019analyse':
    'Näyttää siltä, että teillä ei ole enää analyysiluottoa',
  Bambara: 'Bambara',
  Sortir: 'Ulos!',
  optionel: 'valinnainen',
  'Temps restant': 'Jäljellä oleva aika',
  Ukrainien: 'Ukrainan',
  'Chichewa ; Chewa ; Nyanja': 'Chichewa; Chewa; Nyanja',
  'Votre demande de révision a bien été envoyée.':
    'Tarkistuspyyntösi on lähetetty.',
  'Typix - Créer rédacteur': 'Typix - Luo editori',
  "n'existe pas": 'ei ole olemassa',
  Hindi: 'Hindi',
  'ne peut pas être supprimé car il est lié à des sites web':
    'ei voida poistaa, koska se on linkitetty verkkosivustoihin',
  'Commandes en cours': 'Käynnissä olevat tilaukset',
  'Textes livrés': 'Toimitetut tekstit',
  Validation: 'Validointi',
  'Non attribuées': 'Ei myönnetty',
  'Voulez-vous vraiment désactiver': 'Haluatko todella poistaa',
  'Catalan ; Valencien': 'katalaani; valencialainen',
  'Nombre de textes restants': 'Jäljellä olevien tekstien määrä',
  'Ne doit pas contenir votre nom': 'Ei saa sisältää nimeäsi',
  Documentation: 'Dokumentaatio',
  Kazakh: 'Kazakstan',
  'Numéro invalide': 'Virheellinen numero',
  'Veuillez saisir un texte ou importer un fichier.':
    'Kirjoita teksti tai tuo tiedosto.',
  'Nb de FAQ': 'Usein kysyttyjen kysymysten määrä',
  Analyser: 'Analysoi',
  Turc: 'Turkkilainen',
  'Toute demande n\u2019ayant pas été précisée lors du brief':
    'Kaikki muut kuin toimeksiannossa mainitut pyynnöt',
  Wallon: 'Vallonian',
  Birmane: 'Burman',
  Irlandais: 'Irlantilainen',
  Oriya: 'Oriya',
  'Réinitialiservotre mot de passe': 'Nollaa salasanasi',
  Cuisine: 'Keittiö',
  'Haïtien ; créole haïtien': 'Haitin kieli; Haitin kreoli',
  'Vous ne pouvez pas supprimer le rédacteur': 'Et voi poistaa editoria',
  Validé: 'Validoitu',
  "cet email n'existe pas": 'tätä sähköpostia ei ole olemassa',
  Historique: 'Historia',
  Confirmer: 'Vahvista',
  'à cocher si le nombre de mots est différent par texte':
    'rastitetaan, jos sanojen määrä vaihtelee tekstikohtaisesti.',
  'Fiche du site web ': 'Verkkosivusto',
  Désactiver: 'Deaktivoi',
  'Travaux/BTP': 'Työt/Rakentaminen',
  'La fiche du website': 'Verkkosivujen tiedot',
  'Si le contenu ne respecte pas les règles du brief':
    'Jos sisältö ei noudata tehtävänantoa koskevia sääntöjä',
  Norvégien: 'Norjalainen',
  '0 rédacteurs': '0 kirjoittajat',
  indisponible: 'ei saatavilla',
  Venda: 'Venda',
  Maori: 'Maori',
  'Textes revisés': 'Tarkistetut tekstit',
  'Status texte': 'Tekstin tila',
  'textes livrés en attente de validation':
    'toimitetut tekstit odottavat validointia',
  'Typix - Mon Profile': 'Typix - Oma profiili',
  'le client': 'asiakas',
  Romanche: 'Romanche',
  'URL du site': 'Sivuston URL-osoite',
  'nouvelles notifications': 'uudet ilmoitukset',
  'Divehi ; Dhivehi ; Maldivien': 'Divehi; Dhivehi; Malediivit',
  'Êtes vous sur de vouloir sauvegarder le texte':
    'Haluatko varmasti tallentaa tekstin',
  'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon':
    'Lisää alkuteksti, jotta voit tallentaa tekstin luonnoksena.',
  Xhosa: 'Xhosa',
  'Le contrat pour le client': 'Sopimus asiakkaan kanssa',
  rédacteurs: 'kirjoittajat',
  'Ce champ est obligatoire': 'Tämä kenttä on pakollinen',
  'Tarif/Mot': 'Hinta/sana',
  Tadjik: 'Tadžikistan',
  'Réf devis': 'Viite lainaus',
  'Rechercher un rédacteur': 'Etsi kirjailija',
  Albanais: 'Albanian',
  Galicien: 'Galician',
  Disponibilité: 'Saatavuus',
  'Les deux mots de passe ne sonts pas identiques':
    'Nämä kaksi salasanaa eivät ole identtisiä',
  Tibétain: 'Tiibetiläinen',
  'Typix - Gestion des utilisateurs': 'Typix - Käyttäjien hallinta',
  'Ossétien ; Ossétique': 'ossetialainen; ossetialainen',
  Tswana: 'Tswana',
  'Ajouter un client': 'Lisää asiakas',
  'Séparez les mots-clés par un " Enter ".': 'Erottele avainsanat Enterillä.',
  'Zhuang ; Chuang': 'Zhuang; Chuang',
  Thématiques: 'Teemat',
  'Nb mots/texte': 'Sanojen/tekstin määrä',
  Commerce: 'Kauppa',
  'Voir les commandes': 'Katso tilaukset',
  'Nombre de mots par texte': 'Sanojen määrä tekstiä kohti',
  'Lien drive...': 'Linkki ajaa...',
  'Hollandais ; Flamand': 'hollantilainen; flaamilainen',
  'Mon profil': 'Profiilini',
  "Ce champs doit être sup à 0 car facturation n'est pas au réel":
    'Tämän kentän on oltava suurempi kuin 0, koska laskutus ei ole todellista.',
  'Le texte a été validé avec succès': 'Teksti on validoitu onnistuneesti',
  Jeux: 'Pelit',
  'Voulez-vous vraiment supprimer la ligne de commande pour':
    'Haluatko todella poistaa komentoriviltä komennon',
  'Ndebele, Nord ; Ndebele Nord': 'Ndebele, pohjoinen; Ndebele pohjoinen',
  'Slave ecclésiastique ; vieux slavon ; slavon ecclésiastique ; vieux bulgare ; vieux slavon ecclésiastique':
    'kirkkoslaavin kieli; vanha slaavilainen kieli; kirkkoslaavin kieli; vanha bulgarian kieli; vanha kirkkoslaavin kieli.',
  Swahili: 'Swahili',
  Voyage: 'Matkailu',
  'Nombre de mot à ajouter': 'Lisättävien sanojen määrä',
  'Liste des rédacteurs': 'Luettelo kirjoittajat',
  'le rédacteur': 'toimittaja',
  Kanuri: 'Kanuri',
  rédacteur: 'toimittaja',
  Tatar: 'Tatar',
  'Roumain ; Moldave ; Moldovan': 'Romanian; Moldovan',
  'Le texte initial de': 'Alkuperäinen teksti',
  'Mail clients': 'Asiakkaan posti',
  'Le contrat de': 'Sopimus',
  'au moins une lettre minuscule et une lettre majuscule,un caractère spécial et un chiffre':
    'vähintään yksi pieni ja yksi iso kirjain, yksi erikoismerkki ja yksi numero.',
  Transport: 'Liikenne',
  'Nombre total de mots (existants et ajoutés) :':
    'Sanojen kokonaismäärä (olemassa olevat ja lisätyt) :',
  'Rechercher par mail, prénom, nom, site...':
    'Haku sähköpostin, etunimen, sukunimen, sivuston...',
  'Nombre de mot à ajouter (Min/Max) : ':
    'Lisättävien sanojen määrä (Min/Max) :',
  Compte: 'Tili',
  'Tourisme/Loisirs': 'Matkailu/Vapaa-aika',
  'Nouveau texte': 'Uusi teksti',
  Max: 'Max',
  'Kalaallisut ; Groenlandais': 'Kalaallisut; grönlantilainen',
  'Oups...!il y a une/plusieurs erreur(s) dans la fenêtre du gap sémantique. Veuillez vérifier son contenu pour la/les corriger et soumettre à nouveau votre texte.':
    'Hups...! Semanttisen aukon ikkunassa on yksi tai useampi virhe. Tarkista sen sisältö korjataksesi ne ja lähetä tekstisi uudelleen.',
  'ne peut pas être supprimé pour le moment': 'ei voida poistaa tällä hetkellä',
  'Le texte': 'Teksti',
  URL: 'URL',
  "Un utilisateur existe déjà avec l'email":
    'Käyttäjä on jo olemassa, jolla on sähköpostiosoite',
  Cree: 'Cree',
  Prénom: 'Etunimi',
  'commandes prête': 'tilaukset valmiina',
  Réinitialiser: 'Nollaa',
  'Veuillez fournir une date valide': 'Anna voimassa oleva päivämäärä',
  'Kuanyama ; Kwanyama': 'Kuanyama; Kwanyama',
  'Luxembourgeois ; Letzeburgesch': 'Luxemburgin kieli; Letzeburgesch',
  Suédois: 'Ruotsalainen',
  'Confirmer le mot de passe': 'Vahvista salasana',
  'Ce champs est obligatoire et ne peut avoir que des nombres':
    'Tämä kenttä on pakollinen, ja siinä voi olla vain numeroita',
  Sciences: 'Tiede',
  Tchétchène: 'Tšetšenia',
  "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer":
    'on sivuston ainoa asiakas, muita on lisättävä, jotta se voidaan poistaa.',
  'Le mot de passe de confirmation ne correspond pas':
    'Vahvistussalasana ei täsmää',
  Swati: 'Swati',
  Danois: 'Tanskalainen',
  Sauvegarder: 'Tallenna',
  'Veuillez changer les informations suivantes titre et/ou mot clé':
    'Muuttakaa seuraavat tiedot: otsikko ja/tai avainsana.',
  'importer un document': 'asiakirjan tuominen',
  Maltais: 'Maltan',
  'Nb de mots': 'Sanojen lukumäärä',
  'Les données fournies sont invalides': 'Toimitetut tiedot ovat virheellisiä',
  'Livraison estimée': 'Arvioitu toimitusaika',
  'Grec moderne (1453-)': 'Nykykreikka (1453-)',
  Avestan: 'Avestan',
  Inuktitut: 'Inuktitut',
  'Nombre total de mots ajoutés': 'Lisättyjen sanojen kokonaismäärä',
  'le contenu présente des inexactitudes': 'sisältö sisältää epätarkkuuksia',
  Finnois: 'Suomalainen',
  'Ajouter un admin': 'Lisää ylläpitäjä',
  'Min/Max': 'Min/Max',
  'Modifier le consultant': 'Muokkaa konsulttia',
  'Liste des clients': 'Asiakasluettelo',
  'Nom client': 'Asiakkaan nimi',
  Vert: 'Vihreä',
  'Mots clés manquants': 'Puuttuvat avainsanat',
  Lao: 'Lao',
  Somali: 'Somali',
  'Nb de silo par texte': 'Siilojen lukumäärä tekstiä kohti',
  Italien: 'Italian',
  'La commande a été mis à jour avec succès !':
    'Tilaus on päivitetty onnistuneesti!',
  Bosniaque: 'Bosnian',
  'Thématiques d\u2019expertise': 'Asiantuntijuuden teemat',
  'Ce mot de passe est le mot de passe que vous avez oublié':
    'Tämä on unohtamasi salasana',
  'a été désactivé avec succès': 'on onnistuneesti poistettu käytöstä',
  Kongo: 'Kongo',
  'Postuler à la commande': 'Tilauksen hakeminen',
  'mot-clé': 'avainsana',
  Abkhazien: 'Abhasian',
  Mongolien: 'Mongolian',
  'Typix - Fiche site web': 'Typix - Verkkosivusto',
  'Mail envoyé': 'Lähetetty posti',
  Géorgien: 'Georgian',
  'Si des phrases ne sont pas dans un français correct':
    'Jos lauseet eivät ole oikeaa ranskaa',
  'En cours': 'Käynnissä',
  voir: 'katso',
  "Date d'ajout": 'Lisätty päivämäärä',
  'Tarif au mot': 'Hinta sanaa kohti',
  Thai: 'Thai',
  'Détails du texte': 'Tekstin yksityiskohdat',
  'Commandes en retard': 'Myöhästyneet tilaukset',
  disponible: 'saatavilla',
  Droit: 'Laki',
  Azerbaïdjanais: 'Azerbaidžan',
  'Ajouter un consultant': 'Lisää konsultti',
  'Dans le cadre d\u2019une repasse sur des contenus, seuls les éléments suivants seront pris en charge':
    'Sisältöä toistettaessa tuetaan vain seuraavia kohteita',
  'doit comprendre au moins 8 charactères': 'on oltava vähintään 8 merkkiä',
  'Titre de la commande': 'Tilauksen otsikko',
  'Langues bihari': 'Biharin kielet',
  'Livraison estimé au': 'Arvioitu toimitus mennessä',
  "Le nombre de texte de la commande ne peut pas être inférieur aux nombre de textes attribuées au(x) rédacteur(s). Veuillez d'abord modifier les informations de la ligne de commande":
    'Tilauksessa olevien tekstien määrä ei voi olla pienempi kuin kirjoittajalle (kirjoittajille) annettujen tekstien määrä. Muuta ensin komentorivin tiedot',
  'Date de livraison': 'Toimituspäivä',
  'Voulez-vous vraiment supprimer le contrat de': 'Haluatko todella lakkauttaa',
  'Facturation au réel': 'Todellinen laskutus',
  'Gap sémantique': 'Semanttinen aukko',
  Estonien: 'Viron',
  Wolof: 'Wolof',
  'Coût d\u2019achat max/mot': 'Maksimi ostokustannus/sana',
  'Détail de la commande': 'Tilauksen tiedot',
  'Export en cours de téléchargement\u2026': 'Vienti ladataan...',
  'Ce champ est obligatoire et doit être inférieur ou égal au Nombre total des textesde la commande':
    'Tämä kenttä on pakollinen, ja sen on oltava pienempi tai yhtä suuri kuin tilauksen tekstien kokonaismäärä.',
  Arabe: 'Arabia',
  Bislama: 'Bislama',
  'Mail client': 'Asiakkaan posti',
  '(Titre, mot clé, url, balise, méta-description)':
    '(Otsikko, avainsanat, url, tag, meta-description)',
  'Typix - Nouvelle commande': 'Typix - Uusi tilaus',
  'Révision en attente': 'Arvostelu vireillä',
  'Le consultant': 'Konsultti',
  Entreprise: 'Yritys',
  Aragonais: 'Aragonialainen',
  Kashmiri: 'Kashmiri',
  'a été activé': 'on aktivoitu',
  'Interlingua (Association internationale des langues auxiliaires)':
    'Interlingua (Kansainvälinen apukielten yhdistys)',
  Actualités: 'Uutiset',
  'Votre décision a été prise en compte avec succès':
    'Päätöksesi on onnistuneesti otettu huomioon',
  Afrikaans: 'Afrikaans',
  'contenu en attente de vérification client':
    'sisältö odottaa asiakkaan vahvistusta',
  'Fiche du rédacteur': 'Toimittajan tiedosto',
  Outillage: 'Työkalut',
  'Typix - Détails de la commande': 'Typix - Tilauksen tiedot',
  'Ajouter ou compléter ci-dessous votre contenu :':
    'Lisää tai täydennä sisältösi alla:',
  Ewe: 'Ewe',
  'contenu en attente de repasse rédacteur':
    'sisällön toistoa odottava toisto-editori',
  'La commande a été supprimé avec succès': 'Tilaus poistettiin onnistuneesti',
  'Expressions ou phrases françaises mais ne vous convenant pas':
    'Ranskalaiset ilmaisut tai fraasit, jotka eivät sovi sinulle.',
  Corse: 'Korsika',
  Modifier: 'Muokkaa',
  'Nb de GMB': 'GMB:iden lukumäärä',
  Oromo: 'Oromo',
  Polish: 'Puolan',
  'Insérez votre gap sémantique avec l’occurrence':
    'Lisää semanttinen aukkosi esiintymän',
  'Nb de textes à optimiser': 'Optimoitavien tekstien määrä',
  Mode: 'Tila',
  Akan: 'Akan',
  'Révisions effectués': 'Tehdyt tarkistukset',
  'Modifier l\u2019admin': 'Muokkaa admin',
  'Télécharger le document': 'Lataa asiakirja',
  Hausa: 'Hausa',
  'Notes rédacteurs': 'Toimittajien huomautukset',
  Quechua: 'Quechua',
  Féroïen: 'Färsaaret',
  'Modifier le rédacteur': 'Vaihda editoria',
  Mail: 'Posti',
  Rédacteurs: 'Kirjailijat',
  'Typix - Détails du texte': 'Typix - Tekstin tiedot',
  Hongrois: 'Unkarilainen',
  'Bon pour livraison': 'Hyvä toimitus',
  'Au réel': 'Todellisessa maailmassa',
  'Hiri Motu': 'Hiri Motu',
  Hébreu: 'Heprea',
  'Nombre total de mots ajoutés :': 'Lisättyjen sanojen kokonaismäärä :',
  Komi: 'Komi',
  'Doit être inférieur au nombre maximum':
    'Sen on oltava pienempi kuin enimmäismäärä',
  'Nom du texte': 'Tekstin nimi',
  'Ajouter un rédacteur': 'Lisää toimittaja',
  Ou: 'Tai',
  Utilisateurs: 'Käyttäjät',
  Heures: 'Tunnit',
  'Santé/Bien-être': 'Terveys/hyvinvointi',
  'Interlingue ; Occidental': 'Kieltenvälinen; länsimainen',
  'Luba-Katanga': 'Luba-Katanga',
  Letton: 'Latvian',
  Anglais: 'Englanti',
  Envoyer: 'Lähetä',
  'Tableau de bord': 'Kojelauta',
  'Demande de révision': 'Tarkistuspyyntö',
  'Résultat sémantique': 'Semanttinen tulos',
  'Chercher un rédacteur': 'Toimittajan etsiminen',
  'Ce champs est obligatoire': 'Tämä kenttä on pakollinen',
  Rédaction: 'Toimitus',
  'Modifier le client': 'Muokkaa asiakasta',
  'Voulez-vous vraiment supprimer le rédacteur':
    'Haluatko todella poistaa editorin',
  Titre: 'Otsikko',
  Langue: 'Kieli',
  'Les demandes suivantes ne seront pas prises en compte':
    'Seuraavia hakemuksia ei oteta huomioon',
  'délai dépassé': 'myöhästynyt määräaika',
  Tchouvache: 'Tchouvache',
  Ganda: 'Ganda',
  Twi: 'Twi',
  'Contrat déjà existant, veuillez modifier les informations':
    'Olemassa oleva sopimus, muuttakaa tietoja',
  Igbo: 'Igbo',
  Yiddish: 'Jiddish',
  'Limburgan ; Limburger ; Limburgish': 'Limburgan; Limburger; Limburgish',
  'Commandes validées': 'Validoidut tilaukset',
  'listeRedacteur-': 'listRedactor-',
  Étape: 'Vaihe',
  'Energie/Environnement': 'Energia/Ympäristö',
  Min: 'Min',
  Gujarati: 'Gujarati',
  'ne doit pas inclure votre nom/prénom': 'ei saa sisältää nimeäsi/etunimeäsi',
  'Typix - Fiche rédacteur': 'Typix - Kirjoittajan tiedosto',
  'révisions effectuées en attentes de validation':
    'validointia odottavat tarkistukset',
  'Textes validés': 'Validoidut tekstit',
  Art: 'Taide',
  Dzongkha: 'Dzongkha',
  Polyvalent: 'Monipuolinen',
  Sundanese: 'Sundanese',
  'Nb total de textes': 'Tekstien kokonaismäärä',
  'Nombre de mots gérés': 'Hallinnoitujen sanojen määrä',
  "L'émail": 'Emali',
  'Afficher les résultats': 'Näytä tulokset',
  'Frison occidental': 'länsifriisiläinen',
  'Modification effectuée avec succès': 'Muutos onnistuneesti suoritettu',
  'Balise titre': 'Otsikkotunniste',
  'Typix - Mon profil': 'Typix - Oma profiili',
  'email invalide': 'virheellinen sähköpostiosoite',
  'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon':
    'Lisää url, jotta voit tallentaa tekstin luonnoksena.',
  Macédonien: 'Makedonia',
  'Votre candidature a bien été envoyée': 'Hakemuksesi on lähetetty',
  'E-mail': 'Sähköposti',
  Fulah: 'Fulah',
  'Ajouter ou compléter ci-dessous votre contenu':
    'Lisää tai täydennä sisältösi alla',
  Manx: 'Manx',
  'Ajout de mots-clés avec la fréquence restante':
    'Avainsanojen lisääminen jäljellä olevalla taajuudella',
  'Fiche du site web': 'Verkkosivusto',
  Contacter: 'Ota yhteyttä',
  Fidjien: 'Fidžiläinen',
  Déconnexion: 'Kytkennän katkaisu',
  email: 'sähköpostiosoite',
  'Nombre de textes': 'Tekstien määrä',
  'Enregistrer et informer client':
    'Asiakkaiden rekisteröinti ja tiedottaminen',
  'Date de validation': 'Validointipäivä',
  'Tonga (Îles Tonga)': 'Tonga (Tongan saaret)',
  Javanais: 'Javanilainen',
  Portugais: 'Portugalin',
  Biélorusse: 'Valko-Venäjän',
  'Pour ajouter un nouveau texte': 'Uuden tekstin lisääminen',
  'Enfant/Puéri': 'Lapsi/Puperium',
  'Mots clés': 'Avainsanat',
  Emploi: 'Työllisyys',
  'Voulez-vous vraiment supprimer la commande de': 'Haluatko todella poistaa',
  'Mot clé': 'Avainsana',
  Consultants: 'Konsultit',
  Volapük: 'Volapük',
  Services: 'Palvelut',
  'mot-clé (fréquence)': 'avainsana (taajuus)',
  'Ne plus afficher ce message': 'Älä näytä tätä viestiä uudelleen',
  Consultant: 'Konsultti',
  "Une erreur s'est produite": 'On tapahtunut virhe',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial':
    'Vähintään 8 merkkiä, joissa on iso kirjain, numero, erikoismerkki ja erikoismerkki',
  'Pushto ; Pashto': 'Pushto; Pashto',
  Français: 'Ranskan',
  validées: 'validoitu',
  'Url du site': 'Sivuston Url',
  Précédent: 'Edellinen',
  'car celui-ci a déjà rédigé des textes':
    'koska jälkimmäinen on jo laatinut tekstejä',
  'Kikuyu ; Gikuyu': 'Kikuyu; Gikuyu',
  Brouillons: 'Luonnokset',
  Ido: 'Ido',
  'Contenu disponible': 'Saatavilla oleva sisältö',
  Enseignement: 'Opetus',
  'a été livré avec succès': 'on toimitettu onnistuneesti',
  Chinois: 'Kiinalainen',
  Vietnamien: 'Vietnamilainen',
  'Nouveau client': 'Uusi asiakas',
  'Votre profil a été mis à jour avec succès.':
    'Profiilisi on päivitetty onnistuneesti.',
  Consignes: 'Ohjeet',
  'Mot de passe': 'Salasana',
  Annuler: 'Peruuta',
  Non: 'Ei',
  Nom: 'Nimi',
  Guarani: 'Guarani',
  "il y'a des commandes liés à au site web":
    'verkkosivustoon liittyy tilauksia',
  Score: 'Pisteet',
  'Mot de passe mis à jour avec succès': 'Salasana päivitetty onnistuneesti',
  Latin: 'Latinankielinen',
  Technologie: 'Teknologia',
  Internet: 'Internet',
  Nauru: 'Nauru',
  'a été créé avec succès': 'on luotu onnistuneesti',
  Roumain: 'Romanian',
  Assamais: 'Assamilainen',
  'Khmer central': 'Keski-Khmeri',
  'Navajo ; Navaho': 'Navajo; Navaho',
  'Panjabi ; Punjabi': 'Punjabi; Punjabi',
  'Analyse/Limite': 'Analyysi/raja',
  Grec: 'Kreikkalainen',
  Ojibwa: 'Ojibwa',
  'Mes Projets': 'Minun projektini',
  'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n\u2026':
    'avainsana1 (2)\navainsana2 (1)\navainsana3 (1)\navainsana4 (2)\n...',
  'ajouter un texte': 'lisätä tekstiä',
  'Détail de la prestation': 'Palvelun yksityiskohdat',
  "Vous avez la possibilité d'exporter le rapport d'une, ou de plusieurs commandes. Pour exporter toutes les commandes d'un client, il vous suffit juste de cliquer sur l'icône de téléchargement en jaune":
    'Sinulla on mahdollisuus viedä yhden tai useamman tilauksen raportti. Voit viedä kaikki asiakkaan tilaukset napsauttamalla keltaista latauskuvaketta.',
  'Gestion des utilisateurs': 'Käyttäjien hallinta',
  'livré et inférieur au nombre de texte non affecté':
    'ja vähemmän kuin jakamattomien tekstien määrä.',
  'Date deadline validation client': 'Asiakkaan validoinnin määräaika',
  Aymara: 'Aymara',
  Validées: 'Validoitu',
  Notes: 'Huomautukset',
  'Nombre de GMB': 'GMB:iden lukumäärä',
  'résultats sur': 'tulokset',
  'Prénom / Nom du client': 'Etunimi / Asiakkaan nimi',
  'Tout télécharger': 'Lataa kaikki',
  'Champs obligatoires': 'Pakolliset kentät',
  Éditer: 'Muokkaa',
  'Coller le texte initial dans le champs ci-dessous':
    'Liitä alkuperäinen teksti alla olevaan kenttään',
  'ID rédacteur': 'Toimittajan tunnus',
  Arménien: 'Armenian',
  'Grande distribution': 'Laajamittainen jakelu',
  Welsh: 'Welsh',
  Herero: 'Herero',
  'Enrichissement sémantique': 'Semanttinen rikastaminen',
  'Détail de la prestation du contenu': 'Sisällön toimittamisen yksityiskohdat',
  Noir: 'Musta',
  'Ajouter un texte': 'Lisää teksti',
  Traduction: 'Käännös',
  'Immo/Defisc': 'Omaisuus/Verotus',
  'Brief détaillé': 'Yksityiskohtainen lyhyt kuvaus',
  'Séparez les mots-clés par un Enter .': 'Erottele avainsanat Enterillä .',
  Prix: 'Palkinnot',
  'mot de passe oublié': 'Unohtunut salasana',
  'Ndebele, South ; South Ndebele': 'Ndebele, Etelä; Etelä-Ndebele',
  'Demander une révision': 'Pyydä arvostelua',
  'Demander une repasse globale': 'Pyytää kokonaisvaltaista tarkistusta',
  'Sotho, Southern': 'Sotho, eteläinen',
  'Le titre de la commande existe déjà': 'Tilauksen nimi on jo olemassa',
  'Félicitations !': 'Onnittelut!',
  Kurde: 'Kurdi',
  Adresse: 'Osoite',
  Espagnol: 'Espanjan',
  Ndonga: 'Ndonga',
  'En retard': 'Myöhäinen',
  'a été ajouté avec succès': 'on onnistuneesti lisätty',
  Commandes: 'tilaukset',
  'a été mis en brouillon': 'on laadittu',
  'Rédacteur attribué': 'Nimetty toimittaja',
  Rechercher: 'Etsi',
  'Nouvelle commande': 'Uusi tilaus',
  'Commandes non attribuées': 'Kohdentamattomat tilaukset',
  'Le texte a été mis en brouillon': 'Teksti on laadittu',
  'Contact edito': 'Ota yhteyttä edito',
  Langues: 'Kielet',
  Orange: 'Oranssi',
  'Nynorsk norvégien': 'norjaksi Nynorsk',
  Shona: 'Shona',
  Turkmène: 'Turkmenistan',
  'contenu repassé, en attente validation client':
    'silitetty sisältö, joka odottaa asiakkaan vahvistusta',
  'Nombre de mots rédigés': 'Kirjoitettujen sanojen määrä',
  Malay: 'Malaiji',
  'Nombre de Silo': 'Siilon määrä',
  Oui: 'Kyllä',
  Automobile: 'Autoteollisuus',
  Résultats: 'Tulokset',
  Afar: 'Afar',
  'Tâche - id tâche': 'Tehtävä - tehtävän tunnus',
  'Ce champ est obligatoire doit être supérieur à 0':
    'Tämä kenttä on pakollinen ja sen on oltava suurempi kuin 0.',
  'Vous êtes sûr': 'Oletko varma, että',
  'Réinitialiser votre mot de passe': 'Nollaa salasanasi',
  Sindhi: 'Sindhi',
  Bengali: 'Bengali',
  'Bokmål, norvégien ; Bokmål norvégien':
    'Bokmål, norjalainen; norjalainen Bokmål',
  'Nombre de Jours': 'Päivien lukumäärä',
  'Min/Max mots': 'Min/Max sanat',
  Slovène: 'Slovenian',
  Site: 'Verkkosivusto',
  'Sinhala ; Cingalais': 'Sinhala; singhalesialainen',
  Bulgare: 'Bulgarian',
  'Liste des commandes': 'Luettelo tilauksista',
  "L'utilisateur": 'Käyttäjä',
  Uzbek: 'Uzbekistan',
  'Titre du texte': 'Tekstin otsikko',
  Postuler: 'Hae osoitteessa',
  'Nb de textes par Silo': 'Tekstien lukumäärä siiloa kohti',
  'Nombre total de mots (existants et ajoutés)':
    'Sanojen kokonaismäärä (olemassa olevat ja lisätyt)',
  'Max.': 'Max.',
  Beauté: 'Kauneus',
  Humanitaire: 'Humanitaarinen',
  Telugu: 'Telugu',
  'Recherche par rédacteur ou texte':
    'Etsi kirjoittajan tai tekstin perusteella',
  'Balise meta-description': 'Meta description tag',
  Malgache: 'Malagasy',
  Tagalog: 'Tagalog',
  'Ce champs doit être sup à 0 et inférieur à 1':
    'Tämän kentän on oltava suurempi kuin 0 ja pienempi kuin 1.',
  'Le rédacteur': 'Toimittaja',
  'a été mis à jour avec succès': 'on onnistuneesti päivitetty',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un symbole et ne pas être identique au nom.':
    'Vähintään 8 merkkiä, joissa on iso kirjain, numero tai symboli ja jotka eivät ole identtisiä nimen kanssa.',
  'textes en plus': 'lisää tekstejä',
  'Format souhaité': 'Haluttu muoto',
  Chamorro: 'Chamorro',
  Malayalam: 'Malayalam',
  'Détail ligne de commande': 'Tilausrivin tiedot',
  'Veuillez préciser la date': 'Täsmennä päivämäärä',
  Pali: 'Pali',
  Clients: 'Asiakkaat',
  'Total facturé': 'Laskutettu yhteensä',
  'contenu validé par le client': 'asiakkaan vahvistama sisältö',
  'Occitan (post 1500)': 'oksiittia (vuoden 1500 jälkeen)',
  Japonais: 'Japanilainen',
  Avaric: 'Avaric',
  'Voulez-vous vraiment activer': 'Haluatko todella aktivoida',
  Sanskrit: 'Sanskrit',
  'Toutes les notifications': 'Kaikki ilmoitukset',
  Marathi: 'Marathi',
  Persan: 'Persialainen',
  'La commande pour le client': 'Asiakkaan tilaus',
  'Intitulé de la commande': 'Tilauksen otsikko',
  Samoan: 'Samoalainen',
  Autres: 'Muut',
  Sport: 'Urheilu',
  "il y'a des commandes liés au site web ": 'verkkosivustoon liittyy tilauksia',
  'Ajout de mots-clé avec la fréquence restante':
    'Avainsanojen lisääminen jäljellä olevalla taajuudella',
  'a été supprimé avec succès': 'on onnistuneesti poistettu',
  Postulé: 'Lähetetty',
  Literie: 'Vuodevaatteet',
  'Édité par le client': 'Asiakkaan toimittama',
  Cornouailles: 'Cornwall',
  Tigrinya: 'Tigrinya',
  Textes: 'Tekstit',
  'Soumettre un nouveau texte': 'Lähetä uusi teksti',
  Téléphone: 'Puhelin',
  Deadline: 'Määräaika',
  "Une erreur s'est produite. Veuillez vérifier votre saisie ou essayer plus tard.":
    'On tapahtunut virhe. Tarkista syöttösi tai yritä myöhemmin uudelleen.',
  Marshallais: 'Marshall',
  "La demande d'ajout de crédit est envoyée":
    'Pyyntö luoton lisäämisestä lähetetään',
  'Le rédacteur ': 'Toimittaja',
  'Demander des crédits': 'Luoton hakeminen',
  "Cette commande n'existe pas": 'Tätä komentoa ei ole olemassa',
  Inupiaq: 'Inupiaq',
  Tahitien: 'Tahitilainen',
  Admins: 'Ylläpitäjät',
  'Mettez des mots-clés avec fréquence': 'Aseta avainsanat taajuudella',
  Notifications: 'Ilmoitukset',
  'en retard': 'myöhään',
  "l'admin": 'ylläpitäjä',
  'Mail rédacteurs': 'Mail-toimittajat',
  Amharique: 'Amharic',
  Societe: 'Yritys',
  Tsonga: 'Tsonga',
  'Nombre de textes ajoutés': 'Lisättyjen tekstien määrä',
  Société: 'Yritys',
  Yoruba: 'Joruba',
  'Le texte a été livré avec succès': 'Teksti toimitettiin onnistuneesti',
  'Mettez votre texte': 'Laita tekstisi',
  "Oups....! Une erreur s'est produite": 'Hups....! On tapahtunut virhe',
  'Prénom/Nom': 'Etunimi/sukunimi',
  'Max doit être sup à Min': 'Max on oltava suurempi kuin Min',
  'Importer un autre document': 'Tuo toinen asiakirja',
  'Votre demande a expirée .. veuillez refaire une autre':
    'Hakemuksesi on vanhentunut ... tee uusi hakemus.',
  'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon':
    'Korjatkaa semanttisen aukon muoto, jotta voitte tallentaa tekstin luonnoksena.',
  Exemple: 'Esimerkki',
  Slovaque: 'Slovakian',
  Finance: 'Rahoitus',
  Réactiver: 'Aktivoi uudelleen',
  'Nb textes': 'Tekstien lukumäärä',
  'Intitulé commande': 'Tilauksen nimi',
  Supprimer: 'Poista',
  Brouillon: 'Luonnos',
  'Mots clés restants': 'Jäljellä olevat avainsanat',
  Date: 'Päivämäärä',
  Rôle: 'Rooli',
  'Ce champs doit être sup à 0': 'Tämän kentän on oltava suurempi kuin 0',
  'Maison/Déco': 'Koti/koriste',
  'Vous avez': 'Sinulla on',
  'Cette ligne de commande ne peut pas être supprimée car une partie de ses textes a été livré':
    'Tätä komentoriviä ei voida poistaa, koska osa sen tekstistä on toimitettu.',
  'vérifiez votre email et cliquez sur le lien pour continuer !':
    'tarkista sähköpostisi ja klikkaa linkkiä jatkaaksesi!',
  Sarde: 'Sardinia',
  'Note rédacteur': 'Toimittajan huomautus',
  'Uighur ; Uyghur': 'uiguuri; uiguuri',
  Name: 'Nimi',
  'Commandes intelligentes': 'Smart komennot',
  'Commandes avec révision': 'Smart + review komennot',
  'Type de contenu': 'Sisältötyyppi',
  'Fiche produit': 'Tuotetiedot',
  GMB: 'GMB',
  'STORE LOCATOR': 'STORE LOCATOR',
  'Rédaction premium': 'Premium-tekstien kirjoitus',
  'Rédaction avec révision': 'Smart + review tekstien kirjoitus',
  'Rédaction intelligente': 'Smart tekstien kirjoitus',
  PREMIUM: 'PREMIUM',
  Type: 'Tyyppi',
  Editer: 'Muokkaa',
  'Tous les types': 'Kaikki tyypit',
  Smart: 'Smart',
  'Smart + review': 'Smart + review',
  'Factures traitées': 'Käsitellyt laskut',
  'Factures à valider': 'Laskuja tarkistettavana',
  'Impossible de générer la facture ! Veuillez réessayer':
    'Laskun luominen ei onnistu! Yritä uudelleen',
  'Récapitulatif de facturation': 'Laskutuksen yhteenveto',
  'Demander une modification': 'Pyytää muutosta',
  'Valider et envoyer la facture': 'Hyväksy ja lähetä lasku',
  'Demande de modification': 'Muutoksenpyyntö',
  'La facture a été validé avec succès!': 'Lasku on hyväksytty onnistuneesti!',
  "Oups un erreur c'est produit!": 'Oops, tapahtui virhe!',
  'Nombre de texte': 'Tekstien lukumäärä',
  'Nombre de mot par texte :': 'Sanamäärä per teksti:',
  Paiement: 'Maksu',
  Virement: 'Pankkisiirto',
  Délai: 'Maksuaika',
  'Référence de votre facture': 'Laskunne viite',
  'Coût au mot': 'Sanahinta',
  'Montant global de la commande': 'Tilauksen kokonaismäärä',
  'Votre facture': 'Teidän laskunne',
  'Importer votre facture': 'Tuo laskunne',
  'Pas de fichier disponible': 'Tiedostoa ei ole saatavilla',
  Télécharger: 'Lataa',
  Relancer: 'Uudelleenlähetä',
  'Générer la facture': 'Luo lasku',
  Payée: 'Maksettu',
  'En cours de paiement': 'Maksu käynnissä',
  'En cours de validation': 'Validointi käynnissä',
  'A envoyer': 'Lähetettävä',
  'Modification demandée': 'Muutosta pyydetty',
  'Référence de facture est obligatoire': 'Laskun viite on pakollinen',
  'Le coût au mot doit être un nombre': 'Sanahinnan on oltava numero',
  'Le coût au mot doit être un nombre positif':
    'Sanahinnan on oltava positiivinen numero',
  'Le coût au mot est obligatoire': 'Sanahinta on pakollinen',
  'Le montant global de la commande doit être un nombre':
    'Tilauksen kokonaismäärän on oltava numero',
  'Le montant global de la commande doit être un nombre positif':
    'Tilauksen kokonaismäärän on oltava positiivinen numero',
  'Le montant global de la commande est obligatoire':
    'Tilauksen kokonaismäärä on pakollinen',
  'Bill reference existe déja , veuillez réessayer':
    'Laskun viite on jo olemassa, yritä uudelleen',
  'La facture a été envoyée avec succès!': 'Lasku on lähetetty onnistuneesti!',

  'Montant estimé': 'Arvioitu määrä',
  Action: 'Toiminta',
  Facture: 'Lasku',
  Statut: 'Tila',
  Factures: 'Laskut',
  'Valider la facture': 'Vahvista lasku',
  'La relance a été envoyée avec succès !':
    'Muistutus on lähetetty onnistuneesti!',
  'La demande de modification a été envoyée avec succès !':
    'Muutospyyntö on lähetetty onnistuneesti!',
  'Le cout est trop élevé': 'Kustannukset ovat liian korkeat',
  'Le montant global de la commande est trop élevé ':
    'Tilauksen kokonaismäärä on liian korkea',
  jours: 'päivää',
  'Factures à envoyer': 'Laskut lähetettäväksi',
  'Valider le paiement': 'Vahvista maksu',
  'Générer une facture': 'Generoi lasku',
  'Montant rédacteur': 'Kirjoittajan summa',
  'Montant estimé par Typix': 'Typixin arvioima summa',
  'Voir la modification': 'Näytä muutos',

  'Tag de Titre': 'Otsikkotagi',
  'Meta description': 'Meta-kuvaus',
  'Nom du produit': 'Tuotteen nimi',
  Avantages: 'Edut',
  'Description détaillée': 'Yksityiskohtainen kuvaus',
  'En cours de modification': 'Muokkauksessa',
  'Mes Factures': 'Omat laskuni',
  'En attente de validation': 'Odottaa hyväksyntää',
  'les valeurs négatives ne sont pas autorisées':
    'Negatiiviset arvot eivät ole sallittuja.',
  'Texte Seulement': 'Vain teksti',
  'Traduction Seulement': 'Vain käännös',
  'La relance peut être faite 20 jours après la soumissions de la facture':
    'Muistutus voidaan lähettää 20 päivän kuluttua laskun lähettämisestä',
  Instructions: 'Ohjeet',
  'Votre avis pour la commande': 'Arviosi tilauksesta',
  'Votre évaluation est précieuse pour nous ! Merci !':
    'Arviosi on arvokas meille! Kiitos!',
  "Une erreur s'est produite lors de la soumission de votre évaluation. Veuillez réessayer ultérieurement!":
    'Arviosi lähettämisessä tapahtui virhe. Yritä myöhemmin uudelleen!',
  Evaluer: 'Arvioida',
  Commentaire: 'Kommentti',
  'Votre commantaire': 'Kommenttisi',
  Note: 'Arvosana',
  'Votre retour est précieux pour nous et nous aide à améliorer nos services. Merci de partager votre évaluation avec nous!':
    'Palautteesi on meille arvokasta ja auttaa meitä parantamaan palveluitamme. Kiitos, että jaat arviosi kanssamme!',
  'Verifier la facture': 'Tarkista lasku',

  ' Votre retour est précieux pour nous et nous aide à améliorer nos services.':
    'Palautteenne on meille arvokasta ja auttaa meitä parantamaan palvelujamme.',
  'Notes rédacteur': 'Kirjoittajan huomautukset',
  'Avis client': 'Asiakasarvio',
  'Pas de commantaire': 'Ei kommenttia',
  "Qu'avez vous pensé de votre commande?": 'Mitä ajattelitte tilauksestanne?',
  'Evaluation de la commande': 'Tilauksen arviointi',
  'Rédiger un commentaire': 'Kirjoita kommentti',
  'Contribuez à nous permettre de vous proposer les services de rédaction de la plus haute qualité en partageant vos commentaires.':
    'Ottakaa osaa ja auttakaa meitä tarjoamaan teille korkealaatuisia kirjoituspalveluja jakamalla palautteenne.',
  'Que pouvons-nous améliorer?': 'Mitä voimme parantaa?',
  Continuer: 'Jatkaa',
  'Le dernier texte a été validé avec succès':
    'Viimeisin teksti hyväksyttiin onnistuneesti',
  'Rechercher par rédacteur, commandes, et montant':
    'Etsi kirjoittajan, tilausten ja summan mukaan',
  obligatoire: 'pakollinen',
  'Note admin': 'Ylläpitäjän huomautus',
  'Note client': 'Asiakkaan huomautus',
  Partie: 'Osa',
  'Vous venez de valider tous les contenus rédigés par ':
    'Olet juuri hyväksynyt kaiken sisällön, jonka on kirjoittanut ',
  "Qu'en avez vous pensé": 'Mitä mieltä olit siitä',
  'La facture a été générée avec succès !': 'Lasku on luotu onnistuneesti!',
  'Demande de révision globale': 'Vaadi globaalia tarkastelua',
  Valider: 'Hyväksyä',
  'La taille du titre et/ou la méta-description est trop courte':
    'Otsikon ja/tai meta-kuvauksen pituus on liian lyhyt',

  'Obligatoire en cas d’optimisation ou traduction':
    'Pakollinen optimoinnin tai käännöksen tapauksessa',
  'Mots clés Bourrées': 'Keyword stuffing',
  'Votre commentaire...': 'Kommenttinne...',
  'Ex : "Contenus de très bonne qualité':
    'Esimerkki: "Erittäin hyvälaatuista sisältöä"',
  "pouvez-vous s'il vous plaît reprendre ce/tte rédacteur/rice pour les prochaines commandes?":
    'Voisitteko, ole hyvä, valita tämä kirjoittaja tuleviin tilauksiin?',
  'Ce bouton est pour informer le client que le texte initial, contenait déjà du keyword stuffing':
    'Tämä painike on tarkoitettu ilmoittamaan asiakkaalle, että alkuperäinen teksti sisälsi jo avainsanasuoritusta',
  'Maillage Interne': 'Internal link',
  'Modifier le texte': 'Muokkaa tekstiä',
  Ajouter: 'Lisää',
  'Demande examen': 'Pyyntö tentti',
  'Recherche de mots clés à haute densité': 'Avainsanojen täyttämisen tutkimus',
  'Oups, il semblerait qu’il y ait du keyword stuffing dans votre texte : ':
    'Hups, näyttää siltä, että tekstissäsi on keyword stuffing: ',
  'Oups, il semblerait qu’il y ait du keyword stuffing (trop d’occurrences d’un ou plusieurs mots clés) dans le texte initial.':
    'Hups, näyttää siltä, että alkuperäisessä tekstissä on keyword stuffing (liian monta esiintymää yhdestä tai useammasta avainsanasta).',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).':
    'Varmista, että avainsanan tiheys on optimoitu SEO:ta varten (enintään yksi esiintyminen jokaista 50 sanaa kohti).',
  'Pour cela merci de ne pas retoucher le texte existant et de bien vouloir envoyer une demande d’examen au support.':
    'Tätä varten älä muokkaa olemassa olevaa tekstiä ja lähetä ystävällisesti tutkimuspyyntö tukipalveluun.',
  'Votre demande a été bien envoyée !': 'Pyyntönne on lähetetty onnistuneesti!',
  "Il y a eu un problème lors de l'envoi de votre demande":
    'Ongelma ilmeni lähettäessä pyyntöänne.',
  'Veuillez attendez pour le  keyword Stuffing analyse':
    'Odota avainsanan täyttämisen analysointia.',
  'Inserez le maillage interne': 'Lisää sisäinen linkitys',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).\nSi vous constatez un terme pouvant avoir plusieurs significations (Exemple : Former / Formation/ Forme ou Matelas/Matelassé) , vous pouvez faire une demande d’examen auprès du support.':
    'Varmista, että avainsanatiheys on optimoitu SEO:ta varten (enintään yksi esiintyminen jokaista 50 sanaa kohden).\nJos kohtaat sanan, jolla voi olla useita merkityksiä (Esimerkki: Former / Formation / Form tai Matelas / Matelassé), voit pyytää tarkistusta tukipalvelusta.',
  'Mots clés à haute densité dans le texte actuel':
    'Korkean tiheyden avainsanat nykyisessä tekstissä',
  'Mots clés à haute densité dans le texte initial':
    'Korkean tiheyden avainsanat alkuperäisessä tekstissä',
  'Texte en cours de rédaction !': 'Tekstiä kirjoitetaan parhaillaan !',
  'Êtes-vous sûr(e) de vouloir valider le texte ? Assurez-vous d’abord d’avoir enregistré les modifications.':
    'Oletko varma, että haluat vahvistaa tekstin? Varmista ensin, että olet tallentanut muutokset.',
  "Information dernière minute ! Ton stock de crédits sera bientôt épuisé :( Pour anticiper, n'hésite pas à demander dès maintenant plus de crédits pour terminer ta commande.":
    'Viime hetken tietoa! Luottosaldosi loppuu pian :( Ennakoimiseksi pyydä rohkeasti lisää luottoja nyt tilauksesi loppuunsaattamiseksi.',
  'Voulez-vous confirmer l’URL actuelle ou la modifier ?':
    'Haluatko vahvistaa nykyisen URL-osoitteen vai muuttaa sitä?',
  'Veuillez fournir une URL valide': 'Anna kelvollinen URL-osoite.',
  'Merci de bien vouloir indiquer ci-dessous l’url de la page où a été intégré le contenu:':
    'Ole hyvä ja anna alla olevaan kenttään sivun URL-osoite, jossa sisältö on integroitu:',
  'Contenu en ligne': 'Verkkosisältö',
  'Télécharger le document de révision': 'Lataa tarkistusdokumentti',
  'Date d’envoi': 'Lähetyspäivä',
  Information: 'Tieto',
  Enregistrer: 'Tallenna',
  'Textes en ligne': 'Tekstit verkossa',
  'Livrer les textes': 'Toimita tekstit',
  Indisponible: 'Ei saatavilla',
  Disponible: 'Saatavilla',
  'Les textes ont été livrés avec succès.':
    'Tekstit on toimitettu onnistuneesti.',
  'Le texte a été livré avec succès.': 'Teksti on toimitettu onnistuneesti.',
  'Les textes ont été validés avec succès.':
    'Tekstit on vahvistettu onnistuneesti.',
  'Le texte a été validé avec succès.': 'Teksti on vahvistettu onnistuneesti.',
  'Voulez-vous vraiment valider les Textes de la commande':
    'Haluatko todella vahvistaa tilauksen tekstit?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    'Haluatko todella toimittaa tilauksen tekstit?',
  'Fiche produit longue': 'Pitkä tuotekortti',
  'Fiche produit courte': 'Lyhyt tuotekortti',
  'Un texte est trop long et ne peut pas être exporté sur Excel':
    'Teksti on liian pitkä eikä sitä voida viedä Exceliin.',
  'Mettre un texte en brouillon en livré':
    'Vaihda teksti luonnoksesta toimitetuksi',
  'Remettre un texte validé à livré': 'Vaihda vahvistettu teksti toimitetuksi',
  'Invalider le texte': 'Mitätöi teksti',
  'Je souhaiterai modifier mon mot de passe : comment faire ?':
    'Haluaisin vaihtaa salasanani: kuinka se tehdään?',
  'Comment mettre un contenu en bon pour livraison ?':
    'Kuinka asettaa sisältö toimitusvalmiiksi?',
  'Je ne peux pas mettre mon contenu en « brouillon »':
    'En voi tallentaa sisältöäni "luonnoksena"',
  'Typix n’a pas enregistré mes dernières modifications':
    'Eikö Typix tallentanut viimeisimpiä muutoksiani',
  'Comment rédiger une création de contenu ?':
    'Kuinka kirjoittaa sisällön luominen?',
  'Comment rédiger une optimisation de contenu ?':
    'Kuinka kirjoittaa sisällön optimointi?',
  'Je ne vois plus ma commande – que faire ?':
    'En näe enää tilaustani – mitä tehdä?',
  'Comment générer une facture ?': 'Kuinka luoda lasku?',
  'Je ne peux pas generer ma facture : que faire ?':
    'En voi luoda laskuani: mitä tehdä?',
  'Tuto process Typix global': 'Globaali Typix-prosessi - opastus',
  'Tuto mise en ligne des contenus': 'Sisällön lataus - opastus',
  'Modification mot de passe': 'Salasanan vaihto',
  'Le test ne me convient pas': 'Testi ei sovi minulle',
  'Comment valider un contenu dans Typix ?':
    'Kuinka validoida sisältö Typixissä?',
  'Tuto Facturation': 'Laskutusopas',
  'Le statut du contenu a bien été modifié':
    'Sisällön tila on onnistuneesti muutettu',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'Tämän avainsanan semanttinen aukko ei ole vielä vahvistettu, ota yhteyttä Typix-tukeen: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Tätä avainsanaa ei ole MONETORING-palvelussa, tarkista Typix-tuen kanssa: support-typix@pixalione.com',
  'Récupérer le Gap': 'Palauta väli',
  'Le statut du contenu a bien été modifié':
    'Sisällön tila on onnistuneesti muutettu',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'Tämän avainsanan semanttinen aukko ei ole vielä vahvistettu, ota yhteyttä Typix-tukeen: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Tätä avainsanaa ei ole MONETORING-palvelussa, tarkista Typix-tuen kanssa: support-typix@pixalione.com',
  'Récupérer le Gap': 'Palauta väli',
  'Traduction premium': 'Premium-käännös',
  'Rédaction et/ou Traduction premium': 'Premium-kirjoittaminen ja/tai käännös',
  'Rédaction et/ou Traduction premium': 'Premium-kirjoittaminen ja/tai käännös',
  'Rédaction et/ou Traduction avec révision':
    'Kirjoittaminen ja/tai käännös tarkistuksella',
  'Rédaction et/ou Traduction intelligente':
    'Älykäs kirjoittaminen ja/tai käännös',
  'Traduction avec révision': 'Käännös tarkistuksella',
  'Traduction intelligente': 'Älykäs käännös',
  'Le nombre de mots commandé est supérieur à celui vendu':
    'Tilattujen sanojen määrä on suurempi kuin myytyjen',
  'Rédaction et/ou Traduction premium': 'Premium-kirjoittaminen ja/tai käännös',
  'Rédaction et/ou Traduction smart + review':
    'Älykäs kirjoittaminen ja/tai käännös + tarkistus',
  'Rédaction et/ou Traduction smart': 'Älykäs kirjoittaminen ja/tai käännös',
  'Nom Silo': 'Nimi Silo',
  'Remettre en brouillon': 'Palauta luonnokseksi',
  'Bon pour Livraison Vérifié': 'Vahvistettu toimitettavaksi',
  'Voulez-vous vraiment remettre en brouillon les Textes de la commande':
    'Haluatko varmasti palauttaa tilauksen tekstit luonnokseksi',
  'La vérification du texte a été annulée.': 'Tekstin tarkistus on peruutettu.',
  'Voulez-vous vraiment annuler la vérification du texte?':
    'Haluatko varmasti peruuttaa tekstin tarkistuksen?',
  'Etes-vous sûr(e) de vouloir regénérer tous les contenus ?':
    'Oletko varma, että haluat luoda kaiken sisällön uudelleen?',
  'Je suis sûr(e)': 'Olen varma',
  'Non, revenir en arrière': 'Ei, palaa takaisin',
  'à cocher si la commande a l’intention d’avoir un rédacteur exclusif pour le client':
    'valitse, jos tilauksella on tarkoitus saada yksinoikeudella kirjoittaja asiakkaalle',
  Gouvernance: 'Hallinto',
  'Modification à valider': 'Muutos vahvistettava',
  Rédacteur: 'Toimittaja',
  'Nouveau site web': 'Uusi verkkosivusto',
  'Mail Chef Project': 'Projektipäällikön sähköposti',
  'Site web': 'Verkkosivusto',
  'Liste des siteweb': 'Verkkosivustojen luettelo',
  'Projets non attribuées': 'Määrittämättömät projektit',
  'Projets en cours': 'Käynnissä olevat projektit',
  'Projets en retard': 'Myöhässä olevat projektit',
  'Projets validées': 'Vahvistetut projektit',
  'Projets smart + reviews': 'Smart + review projektit',
  'Projets smart': 'Smart projektit',
  'Ajouter un siteweb': 'Lisää verkkosivusto',
  'Nouveau projet': 'Uusi projekti',
  'Comparaison du score global': 'Comparison of global score',
  'avec le top 3 concurrents': 'with top 3 competitors',
  'Position du mot clé avec le top 3 concurrents': 'Keyword ranking',
  ////////
  Balises: 'Tunnisteet',
  Lisibilité: 'Luettavuus',
  'Longueur des paragraphes': 'Kappaleiden pituus',
  Phrases: 'Lauseet',
  'de +100 mots sur': 'yli +100 sanaa kohteessa',
  Phrase: 'Lause',
  'de +20 mots sur': 'yli +20 sanaa kohteessa',
  'Notre recommandation': 'Suosituksemme',
  'Longueur du texte': 'Tekstin pituus',
  'Formats de contenus variés': 'Monipuoliset sisältöformaatit',
  'par rapport au top 3 de vos concurrents':
    'verrattuna kilpailijoiden top 3:een',
  'Vous êtes': 'Olet',
  'Vous avez un score global de': 'Sinulla on kokonaispisteet',
  'pour une moyenne du secteur à': 'alan keskiarvoon nähden',
  'GAP comblé - Mission accomplie': 'Aukko täytetty – Tehtävä suoritettu',
  'Mots clé restants': 'Jäljellä olevat avainsanat',
  'Phrases de +20 mots': 'Yli 20 sanan lauseet',
  'Titre H1': 'H1-otsikko',
  'Titres H2': 'H2-otsikot',
  'Dans le texte actuel': 'Nykyisessä tekstissä',
  'Dans le texte initial': 'Alkuperäisessä tekstissä',
  mots: 'sanat',
  objectif: 'tavoite',
  phrase: 'lause',
  paragraphe: 'kappale',
  'Temps de lecture': 'Lukuaika',
  'requis ( Bullet point, Bon à savoir,Sommaire)':
    'vaaditaan (luettelomerkit, hyvä tietää, yhteenveto)',
  'de contenu sur': 'sisällön määrä kohteessa',
  'Félicitations ! Le nombre de mots correspond à la quantité d’informations importantes permettant de répondre au sujet':
    'Onnittelut! Sanamäärä vastaa aiheeseen vastaamiseen tarvittavaa tietomäärää.',
  'Félicitations ! Votre contenu ne contient aucune phrase de plus de 20 mots !':
    'Onnittelut! Sisältösi ei sisällä yli 20 sanan lauseita!',
  'Félicitations ! Votre contenu est aéré et facilite la lecture':
    'Onnittelut! Sisältösi on selkeä ja helpottaa lukemista.',
  'Félicitations ! Votre contenu dispose de formats variés qui dynamisent la lecture et permettent d’isoler les informations importantes.':
    'Onnittelut! Sisältösi käyttää monipuolisia formaatteja, jotka tekevät lukemisesta elävämpää ja erottavat tärkeät tiedot.',
  'Félicitations ! Le contenu présente une balise h1 unique et contient le mot clé à l’origine du texte':
    'Onnittelut! Sisältö sisältää ainutlaatuisen H1-tunnisteen ja alkuperäisen avainsanan.',
  'Félicitations ! Le contenu est structuré de façon cohérente et présente au moins 2 balises <h2>':
    'Onnittelut! Sisältö on johdonmukaisesti jäsennelty ja sisältää vähintään kaksi <h2>-tunnistetta.',
  'Félicitations ! Votre contenu contient du maillage interne pondéré et qui ne pollue pas la lecture.':
    'Onnittelut! Sisältö sisältää tasapainoisia sisäisiä linkkejä, jotka eivät häiritse lukemista.',
  'Félicitations ! Le scoring d’enrichissement est supérieur à 85%!':
    'Onnittelut! Rikastuspisteet ovat yli 85 %!',
  'Félicitations ! Votre texte n’est pas suroptimisé sur le mot clé ciblé.':
    'Onnittelut! Tekstisi ei ole liikaa optimoitu kohdeavainsanalle.',
  'Le nombre de mots doit correspondre à la quantité d’informations importantes permettant de répondre au sujet':
    'Sanamäärän tulee vastata tärkeää tietoa, joka tarvitaan aiheen käsittelyyn.',
  'Il est important d’adapter le niveau de vocabulaire en fonction de votre cible. Un vocabulaire simple pourrait l’infantiliser et, à l’inverse, un vocabulaire trop complexe pourrait rendre le contenu inaccessible.':
    'On tärkeää mukauttaa sanasto kohdeyleisölle. Liian yksinkertainen voi alentaa lukijaa, liian monimutkainen voi tehdä sisällöstä vaikeasti ymmärrettävää.',
  'Plus de 70% des internautes ne lisent pas les phrases > 20 mots => Utiliser des phrases concises pour augmenter le temps de rétention sur la page':
    'Yli 70 % käyttäjistä ei lue yli 20 sanan lauseita → Käytä lyhyitä lauseita sivulla pysymisen lisäämiseksi.',
  "Un contenu constitué de blocs de paragraphes trop compact va altérer l'UX et augmenter le taux de rebond.":
    'Liian tiheät kappaleblokit heikentävät käyttäjäkokemusta ja lisäävät poistumisprosenttia.',
  "Multipliez les différents formats d'affichage pour une lecture plus lisible et confortable.":
    'Käytä erilaisia esitysmuotoja lukemisen selkeyttämiseksi ja mukavuuden lisäämiseksi.',
  'Un contenu optimisé doit obligatoirement contenir une seule balise h1 et mentionner le mot clé. ':
    'Optimoidun sisällön tulee sisältää vain yksi H1-tunniste ja mainita avainsana.',
  'Pour une structure de contenu optimale, il faut au moins 2 balises h2.':
    'Optimaaliseen sisältörakenteeseen tarvitaan vähintään kaksi H2-tunnistetta.',
  'Le maillage interne est un très bon moyen de connecter une page avec d’autres pages traitant du même sujet, ou complémentaires.':
    'Sisäiset linkit ovat erinomainen tapa yhdistää sivu muihin samaa aihetta käsitteleviin tai täydentäviin sivuihin.',
  'Un contenu optimisé doit obtenir un scoring d’enrichissement de min 85%. Supprimer du gap sémantique altèrera le scoring d’optimisation':
    'Optimoidun sisällön tulee saavuttaa vähintään 85 % rikastuspisteet. Semanttisen sisällön poistaminen vähentää pistettä.',
  'Répéter le mot trop de fois dans le contenu est pénalisant pour le moteur de recherche. Idéalement, ne pas dépasser un taux de 2.35% (soit environs 2 répétitions pour 100 mots). ':
    'Avainsanan liiallinen toisto rangaistaan hakukoneissa. Ihanteellinen on enintään 2,35 % (n. 2 toistoa 100 sanaa kohden).',
  'Aucune balise H1 trouvée.': 'H1-tunnistetta ei löytynyt.',
  'Balise H1 contient le mot-clé.': 'H1-tunniste sisältää avainsanan.',
  'Balise H1 présente mais sans le mot-clé.':
    'H1-tunniste on olemassa, mutta ei sisällä avainsanaa.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.':
    '{{count_total}} H2-tunnistetta löydetty, {{count_with_kw}} avainsanan kanssa.',
  ' balises H2 trouvées,': ' H2-tunnistetta löydetty,',
  ' avec mot-clé.': ' avainsanan kanssa.',
  'Très facile à lire : Accessible aux enfants ou à des personnes avec un niveau de lecture basique.':
    'Erittäin helppo lukea: Saatavilla lapsille tai peruslukutason omaaville henkilöille.',
  'Facile à lire : Compréhensible par la majorité des adultes et adolescents.':
    'Helppo lukea: Ymmärrettävä useimmille aikuisille ja nuorille.',
  'Difficile à lire : Nécessite un bon niveau de lecture, parfois un bagage académique':
    'Vaikea lukea: Vaatii hyvää lukutaitoa, joskus akateemista taustaa.',
  'Très difficile à lire : Réservé à un public expert ou très averti':
    'Erittäin vaikea lukea: Vain asiantuntijoille tai edistyneille lukijoille.',
  'Wording adapté': 'Sopiva sanamuoto',
  "La balise H1 est essentielle pour l'optimisation SEO.":
    'H1-tunniste on olennainen SEO-optimointiin.',
  'Une seule balise H1 avec le mot-clé est recommandée.':
    'Suositellaan vain yhtä H1-tunnistetta avainsanalla.',
  'Ajoutez le mot-clé dans la balise H1.':
    'Lisää avainsana H1-tunnisteeseen.',
  'Adaptez votre vocabulaire à votre audience. Trop simple infantilise, trop complexe exclut.':
    'Mukauta sanasto yleisöllesi. Liian yksinkertainen alentaa, liian monimutkainen sulkee pois.',
  'Les contenus web se lisent rapidement. Un temps trop long peut décourager.':
    'Verkkosisältö luetaan nopeasti. Liian pitkä lukuaika voi lannistaa.',
  'Information sur la structure': 'Tietoa rakenteesta',
  'Information sur le résultat sémantique': 'Tietoa semanttisesta tuloksesta',
  'Information sur les balises HTML': 'Tietoa HTML-tunnisteista',
  'Information sur le keyword stuffing': 'Tietoa avainsanojen liiallisesta käytöstä',

  //////////////////
  'Derniers contenus rédigés': 'Viimeisimmät kirjoitetut sisällöt',
  'voir plus': 'Näytä lisää',
  'texte': 'Teksti',
  'date d\'ajout': 'Lisäyspäivämäärä',
  'titre du projet': 'Projektin nimi',
  'Date de création': 'Luontipäivä',
  'dernières projets créés': 'Viimeisimmät luodut projektit',
  '% projets par statut de validation :': '% projekteista vahvistustilan mukaan:',
  'non attribués': 'Ei määritetty',
  'en cours': 'Käynnissä',
  'en retard': 'Myöhässä',
  'validées': 'Hyväksytty',
  'smart + reviews': 'Smart + Arvostelut',
  'smart': 'Smart',
  'premium': 'Premium',
  'smart + review': 'Smart + Arviointi',
  'Statut d\'avancement des contenus:': 'Sisällön etenemisen tila:',
  'Nombre de textes publiés :': 'Julkaistujen tekstien määrä:',
  'Nb de textes publiés': 'Julkaistujen tekstien lkm',
  'Top ranked': 'Parhaat sijoitukset',
  'Mot clé': 'Avainsana',
  'Clicks': 'Klikit',
  'Clicks (Y-1)': 'Klikit (Y-1)',
  'Position': 'Sijoitus',
  'Sessions': 'Istunnot',
  'Sessions (Y-1)': 'Istunnot (Y-1)',
  'Evolution performance': 'Suorituskyvyn kehitys',
  'Pourcentage': 'Prosentti',
  'Livré': 'Toimitettu',
  'Publié': 'Julkaistu',
  'Suivez vos contenus et projets en temps réel': 'Seuraa sisältöjäsi ja projektejasi reaaliajassa',
  'Tableau de bord': 'Hallintapaneeli',
  'Titre du projet': 'Projektin nimi',
  'Conversions': 'Konversiot',
  'Impressions': 'Näyttökerrat',
  'Jan': 'Tam',
  'Fév': 'Hel',
  'Mars': 'Maa',
  'Avr': 'Huh',
  'Mai': 'Tou',
  'Juin': 'Kes',
  'Juil.': 'Hei',
  'Août': 'Elo',
  'Sept': 'Syy',
  'Oct': 'Lok',
  'Nov': 'Mar',
  'Déc': 'Jou',
  'Pour activer cette fonctionnalité, ajoutez notre adresse ': 'Ota tämä ominaisuus käyttöön lisäämällä osoitteemme ',
  'à votre ': ' sinun ',
  'Search Console': 'Search Console',
  ', ': ', ',
  'puis cliquez ici pour lancer l’analyse.': 'sitten napsauta tästä aloittaaksesi analyysin.',
  'all devices': 'kaikki laitteet',
  'Desktop': 'Työpöytä',
  'Mobile': 'Mobiili',
  '30 days': '30 päivää',
  '7 days': '7 päivää',
  '90 days': '90 päivää',
  'Aucun projet créé pour le moment.': 'Ei projekteja luotu tällä hetkellä.',
  'Lancer votre premier projet': 'Käynnistä ensimmäinen projektisi',
  'Aucun contenu disponible pour ce site web.': 'Tälle verkkosivustolle ei ole saatavilla sisältöä.',
  'Mes contenus': 'Sisältöni',
  'Type de contenu': 'Sisällön tyyppi',
  'Date d\'ajout': 'Lisäyspäivämäärä',
  'URL': 'URL',
  'Status': 'Tila',
  'Date de livraison': 'Toimituspäivämäärä',
  'Date de validation': 'Hyväksymispäivämäärä',
  'Date de déploiement': 'Julkaisupäivämäärä',
  'Action': 'Toiminto',
  'Aucun contenu pour ce filtre.': 'Ei sisältöä tälle suodattimelle.',
  'Chargement...': 'Ladataan...',
  'Aucun contenu.': 'Ei sisältöä.',
  'Précédent': 'Edellinen',
  'Suivant': 'Seuraava',
  'fiche produit': 'Tuotetiedot',
  'Page catégorie': 'Kategoriapagina',
  'Fiche GMB': 'GMB-sivu',
  'store locator': 'Kauppapaikka',
  'redaction': 'Sisällöntuotanto',
  'traduction': 'Käännös',
  'Fiches produit SEO': 'SEO-tuotetiedot',
  'Derniers projets crées': 'Viimeisimmät luodut projektit',
  'Agent IA': 'AI-agentti',
  'Dérniére mise à jour': 'Viimeisin päivitys',
  'Créer un nouveau contenu': 'Luo uusi sisältö',
  'Rédigez un texte optimisé grâce à l’IA — rapide, pertinent et performant.': 'Kirjoita tekoälyn optimoima teksti – nopea, relevantti ja tehokas.',
  'Validé': 'Hyväksytty',
  'En ligne': 'Verkossa',
  'Fiches GMB': 'GMB-sivut',
  'Fiches store locator': 'Kauppapaikkasivut',
  'Pages catégories': 'Kategoriapagina',
  'Traduction IA': 'AI-käännös',
  'Actions': 'Toiminnot',
  'Traduire un nouveau contenu': 'Käännä uusi sisältö',
  'Traduisez vos contenus automatiquement avec une précision multilingue.': 'Käännä sisältösi automaattisesti monikielisesti tarkasti.',
  'Nom du projet': 'Projektin nimi',
  'Chef de projet': 'Projektipäällikkö',
  'Deadline du projet': 'Projektin määräaika',
  'Informations globales': 'Yleiset tiedot',
  'Contenu du projet': 'Projektin sisältö',
  'Séléctionner le type de contenu': 'Valitse sisältötyyppi',
  'Sélectionner un agent IA personnalisé': 'Valitse mukautettu AI-agentti',
  'Créer un agent IA personnalisé': 'Luo mukautettu AI-agentti',
  'Liens utiles': 'Hyödylliset linkit',
  'Rédacteur(s)': 'Sisällöntuottaja(t)',
  'Deadline': 'Määräaika',
  'Nb textes': 'Tekstien lkm',
  'IA + Revue par rédacteur': 'AI + Sisällöntuottajan tarkastus',
  'Ajouter un projet': 'Lisää projekti',
  'Projets': 'Projektit',
  'Non attribués': 'Ei määritetty',
  'Rédaction IA': 'AI-sisällöntuotanto',
  'Résultats sur': 'Tulokset kohteessa',
  'Êtes-vous sûr de vouloir supprimer cet agent IA ?': 'Haluatko varmasti poistaa tämän AI-agentin?',
  'Mes agents IA': 'Omat AI-agentit',
  'Tous': 'Kaikki',
  'Rédaction': 'Sisällöntuotanto',
  'Traduction': 'Käännös',
  'Rechercher': 'Hae',
  'Sélectionner un site': 'Valitse sivusto',
  'Créer un agent IA personnalisé': 'Luo mukautettu AI-agentti',
  'Définissez la mission, le rôle, la langue, le type de contenu et plus encore.': 'Määritä tehtävä, rooli, kieli, sisältötyyppi ja muuta.',
  'Nouvel agent': 'Uusi agentti',
  'Rôle :': 'Rooli:',
  'Type de contenu :': 'Sisällön tyyppi:',
  'Langue :': 'Kieli:',
  'Siteweb :': 'Verkkosivusto:',
  'GBP': 'GBP',
  'Sélectionner un LLM': 'Valitse LLM',
  'Fiche produit smart': 'Smart-tuotetiedot',
  'Détails du texte': 'Tekstin tiedot',
  '(Mot clé*, URL, Balise titre, Balise méta-description)': '(Avainsana*, URL, Otsikko, Meta-kuvaus)',
  'URL siteweb*': 'Verkkosivuston URL*',
  'Balise titre': 'Otsikko',
  'Balise méta-description': 'Meta-kuvaus',
  'Sélectionner un site web': 'Valitse verkkosivusto',
  'Sélectionner un agent IA': 'Valitse AI-agentti',
  'Lancer': 'Käynnistä',
  'Relancer': 'Käynnistä uudelleen',
  'Génération en cours...': 'Generointi käynnissä...',
  'Générer': 'Generoi',
  'Enregistrement...': 'Tallennetaan...',
  'Enregistrer ': 'Tallenna',
  'Livrer': 'Toimita',
  'Livraison...': 'Toimitetaan...',
  'En ligne...': 'Verkossa...',
  "Derniers contenus ajoutés": "Viimeisimmät lisätyt sisällöt",

  'Nom de l\'agent': 'Agentin nimi',
  'Site web': 'Verkkosivusto',
  'Mission': 'Tehtävä',
  'Langue de traduction': 'Käännöskieli',
  'Langue': 'Kieli',
  'Tonalité': 'Sävy',
  'Cible / Audience': 'Kohdeyleisö',
  'Base de connaissance locale': 'Paikallinen tietopohja',
  'Base de connaissance en ligne': 'Verkossa oleva tietopohja',
  'Sélect. fichiers': 'Valitse tiedostot',
  'Ex: URL1, URL2': 'Esim.: URL1, URL2',
  'Annuler': 'Peruuta',
  'Mettre à jour': 'Päivitä',
  'Valider': 'Vahvista',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages':
    'Esim.: kappale interventiotyypeistä, kappale eduista',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels':
    'Esim.: taitettavat sateenvarjot avautuvat automaattisesti, muut ovat manuaalisia',
  '📚 Base de connaissances': '📚 Tietopohja',

  'Type de produits / services proposés par le site*': 'Sivuston tarjoamat tuotteet/palvelut*',
  'Règles rédactionnelles': 'Kirjoitussäännöt',
  'Lexique recommandé': 'Suositeltu sanasto',
  'Expressions interdites': 'Kielletyt ilmaisut',
  'Instructions de personnalisation': 'Mukautusohjeet',

  "🧩 Informations générales": "🧩 Yleiset tiedot",
  "🗣️ Ton & Audience": "🗣️ Sävy ja yleisö",
  "📝 Structure & Rédaction": "📝 Rakenne ja kirjoittaminen",
  "📚 Base de connaissances": "📚 Tietopohja",
  "Structure de texte attendu": "Odotettu tekstirakenne",
  "Enrichissement SEO": "SEO-optimointi",
  "traduction IA": "AI-käännös",
  "Traduction en cours...": "Käännös käynnissä...",
  "Traduire": "Käännä",
  "Créer votre assistant éditorial sur mesure": "Luo oma räätälöity toimitusassistenttisi",
  "Votre texte traduit": "Käännetty tekstisi",
  "Détail du projet": "Projektin tiedot",
  "Détail d'attribution": "Määrittelytiedot",
  "Détail des contenus": "Sisällön tiedot",

  "Nom agent": "Agentin nimi",
  "Rédaction": "Kirjoittaminen",
  "Traduction": "Käännös",
  "Mots clé": "Avainsanat",
  "Url de la page": "Sivun URL",
  "Entrez le mot clé principal": "Syötä pääavainsana",
  "Entrez l url": "Syötä URL",
  "Date d'ajout": "Lisäyspäivämäärä",
  "Dernière mise à jour": "Viimeisin päivitys",
  "URL": "URL",
  "Status": "Tila",
  "Actions": "Toiminnot",
  "Détails du texte": "Tekstin tiedot",
  "Contenus disponibles": "Saatavilla oleva sisältö",
  "Textes générés": "Luodut tekstit",

  "Veuillez d'abord sélectionner un site web": "Valitse ensin verkkosivusto",
  "Chargement des agents...": "Ladataan agentteja...",
  "Aucun agent disponible pour ce site": "Ei agentteja saatavilla tälle sivustolle",
  "Sélectionner...": "Valitse...",
  "Modifier cet agent": "Muokkaa tätä agenttia",
  "Créer un agent IA personnalisé": "Luo räätälöity AI-agentti",
  "Rédaction en cours...": "Kirjoitus käynnissä...",
  "Génération en cours": "Luonti käynnissä",
  "Rédiger un contenu": "Kirjoita sisältö",
  "Rédiger un lot de contenus": "Kirjoita sisältöerä",
  "Url page": "Sivun URL",
  "Entrez l'URL cible de votre contenu (facultatif).": "Syötä sisältösi kohde-URL (valinnainen).",
  "GAP sémantique": "Semanttinen kuilu",
  "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....":
    "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....",
  "Maillage interne": "Sisäinen linkitys",
  "Introduisez le maillage": "Syötä linkitys",
  "Introduisez le maillage interne": "Syötä sisäinen linkitys",
  "Importer un fichier contenant la liste des thématiques à rédiger et l'IA fera le reste 😊":
    "Tuo tiedosto, joka sisältää kirjoitettavat aiheet, ja AI hoitaa loput 😊",
  "Importer": "Tuo",
  "Saisissez le mot-clé principal de votre contenu.": "Syötä sisältösi pääavainsana.",
  "Texte à traduire": "Käännettävä teksti",
  "Saisissez le texte à traduire": "Syötä käännettävä teksti",
  "Traduire un contenu": "Käännä sisältö",
  "Traduire un lot de contenus": "Käännä sisältöerä",
  "Importer un fichier contenant la liste des textes à traduire et l'IA fera le reste 😊":
    "Tuo tiedosto, joka sisältää käännettävät tekstit, ja AI hoitaa loput 😊",
  "Commencer la traduction": "Aloita käännös",
  "Lancer la traduction": "Käynnistä käännös",
  "Commencer la rédaction": "Aloita kirjoittaminen",
  "Lancer la rédaction": "Käynnistä kirjoittaminen",


  'En ligne...': 'Online...',
  'Ajouter un nouveau site web': 'Lisää uusi verkkosivusto',
  'Créer': 'Luo',
  'Séléctionner ou ajoutez les thématiques qui reflètent votre expertise.': 'Valitse tai lisää aiheita, jotka heijastavat asiantuntemustasi.',
  'Ajoutez ou sélectionnez une thématique': 'Lisää tai valitse aihe.',
  'Le site web a été créé avec succès': 'Verkkosivusto on luotu onnistuneesti',
  'Nous configurons actuellement vos agents IA. Ils seront bientôt prêts à vous assister dans la génération de vos contenus.': 'Konfiguroimme parhaillaan tekoälyagenttejasi. Ne ovat pian valmiita auttamaan sisällöntuotannossa.',
  'Derniers contenus ajoutés': 'Viimeksi lisätty sisältö',
  'Tous les sites': 'Kaikki sivustot',
  'Sélectionner le site web': 'Valitse verkkosivusto',
  'Aucun fichier sélectionné': 'Ei valittua tiedostoa',
  'ex : utilise le vouvoiement, utilise un vocabulaire compréhensible par la cible': 'Esim.: käytä teitittelyä ja kohderyhmälle ymmärrettävää sanastoa.',
  '🧠 Créer un agent IA': '🧠 Luo tekoälyagentti',
  '🧠 Modifier un agent IA': '🧠 Muokkaa tekoälyagenttia',
  'Ex : AMF (Autorité des Marchés Financiers).': 'Esim.: AMF (Rahoitusmarkkinaviranomainen).',
  'Ex: bio, écologique, nom des concurrents': 'Esim.: luomu, ekologinen, kilpailijoiden nimet.',
  'Détailler le plus possible la structure attendue à l\'aide d\'axes de rédaction pour guider l\'IA sur les sujets à traiter et dans quel ordre': 'Kuvaa odotettu rakenne mahdollisimman tarkasti, jotta tekoäly tietää käsiteltävät aiheet ja niiden järjestyksen.',
  'Ajouter des éléments que l\'IA doit ou ne pas faire ou mentionner': 'Lisää asioita, joita tekoälyn tulee tai ei tule tehdä tai mainita.',
  'Ex: prêt-à-porter féminin': 'Esim.: digitaalinen markkinointi',
  'Ex: Rédacteur SEO': 'Esim.: SEO-kirjoittaja',
  'Indiquer la liste des urls sur lesquels l\'IA peut s\'appuyer': 'Ilmoita URL-osoitteet, joihin tekoäly voi tukeutua.',
  'Créez, optimisez, performez : votre contenu prend une nouvelle dimension.': 'Luo, optimoi, suorita: sisältösi saavuttaa uuden tason.',
  'La création de contenu n\'a jamais été aussi smart.': 'Sisällöntuotanto ei ole koskaan ollut näin älykästä.',
  'Boostez votre productivité grâce à la puissance multi-IA. Comparez et combinez les meilleures propositions issues de plusieurs LLM, puis optimisez-les grâce à un score de contenu en temps réel (SEO, lisibilité, pertinence)': 'Tehosta tuottavuuttasi monitekoälyn avulla. Vertaile ja yhdistä eri LLM-mallien parhaat ehdotukset ja optimoi ne reaaliaikaisen sisältöpisteytyksen avulla (SEO, luettavuus, relevanssi).',
  'Je crée mon premier contenu SEO friendly': 'Luo ensimmäinen SEO-ystävällinen sisältöni.',
  'Veuillez coller le texte source....': 'Liitä lähdeteksti, jonka haluat kääntää…',
  'Enrichir': 'Käynnistä',
  'Veuillez d\'abord sélectionner un site web': 'Valitse ensin verkkosivusto',
  "🎯 Commencez ici": "🎯 Aloita tästä",
  "Ajoutez ou sélectionnez le site web que vous souhaitez suivre.": "Lisää tai valitse sivusto, jota haluat seurata.",
  "📝 Derniers contenus créés": "📝 Viimeisimmät luodut sisällöt",
  "Retrouvez ici les derniers contenus créés pour le site sélectionné.": "Täältä löydät valitulle sivustolle luodut viimeisimmät sisällöt.",
  "Cliquez sur un texte pour consulter sa fiche détaillée.": "Napsauta tekstiä nähdäksesi sen tarkemmat tiedot.",
  "📁 Derniers projets créés": "📁 Viimeisimmät luodut projektit",
  "Accédez rapidement aux derniers projets lancés pour ce site.": "Pääset nopeasti sivuston viimeisimpiin projekteihin.",
  "Cliquez sur un projet pour voir son avancement et les contenus associés.": "Napsauta projektia nähdäksesi sen etenemisen ja siihen liittyvät sisällöt.",
  "📊 Suivi de vos projets": "📊 Projektien seuranta",
  "Visualisez la répartition de vos projets : en cours, en retard ou validés.": "Näe projektiesi jakauma: käynnissä, myöhässä tai valmiit.",
  "Une vue d’ensemble claire pour suivre l’état global de votre production.": "Selkeä yleisnäkymä tuotannon tilan seuraamiseen.",
  "📑 Statut d’avancement des contenus": "📑 Sisältöjen edistymisen tila",
  "Suivez ici la répartition de vos contenus : brouillons, livrés et publiés.": "Seuraa sisältöjen jakaumaa: luonnokset, toimitetut ja julkaistut.",
  "Idéal pour identifier rapidement où concentrer vos efforts.": "Ihanteellinen nopeaan arviointiin siitä, mihin keskittyä.",
  "📅 Textes publiés par mois": "📅 Kuukaudessa julkaistut tekstit",
  "Visualisez le nombre de textes publiés chaque mois pour le site sélectionné.": "Näe kuukausittain julkaistujen tekstien määrä valitulla sivustolla.",
  "Suivez ainsi votre rythme de déploiement dans le temps.": "Seuraa näin julkaisutahtiasi ajan mittaan.",
  "⭐ Top mots-clés": "⭐ Parhaat avainsanat",
  "Découvrez vos 5 mots-clés les plus performants issus de la Search Console.": "Tutustu viiteen tehokkaimpaan avainsanaasi Search Consolesta.",
  "Comparez leur position, les clics actuels et les clics de l’année précédente.": "Vertaile niiden sijoitusta, tämänhetkisiä klikkauksia ja edellisvuoden klikkauksia.",
  "📈 Activer le suivi du trafic": "📈 Aktivoi liikenteen seuranta",
  "Ajoutez notre adresse e-mail à votre Search Console pour activer cette analyse.": "Lisää sähköpostiosoitteemme Search Consoleen aktivoidaksesi analyysin.",
  "Vous pourrez ensuite suivre l’évolution de votre trafic directement dans Typix.": "Voit sen jälkeen seurata liikenteen kehitystä suoraan Typixissä.",
  "🏠 Tableau de bord": "🏠 Kojelauta",
  "Revenez à la vue globale : indicateurs clés, contenus récents, projets et performances de votre site.": "Palaa yleisnäkymään: avainmittarit, viimeisimmät sisällöt, projektit ja sivuston suorituskyky.",
  "🤖 Agents IA": "🤖 Tekoälyagentit",
  "Configurez et pilotez vos agents IA pour automatiser la rédaction ainsi que la traduction et gagner du temps sur vos contenus.": "Määritä ja hallitse tekoälyagentteja automatisoidaksesi kirjoittamisen ja kääntämisen sekä säästääksesi aikaa sisällöissä.",
  "✍️ Rédaction IA": "✍️ Tekoälykirjoitus",
  "Accédez aux générateurs IA : fiches produit, fiches GMB, pages catégories et autres contenus optimisés.": "Pääsy tekoälygeneraattoreihin: tuotesivut, GMB-sivut, kategoriasivut ja muu optimoitu sisältö.",
  "🌍 Traduction IA": "🌍 Tekoälykäännökset",
  "Traduisez vos contenus en plusieurs langues en quelques clics tout en conservant la cohérence SEO.": "Käännä sisältösi useille kielille muutamalla napsautuksella säilyttäen SEO-yhtenäisyyden.",
  "➕ Créer un projet": "➕ Luo projekti",
  "Lancez un nouveau projet de contenus en quelques secondes et suivez ensuite son avancement.": "Käynnistä uusi sisältöprojekti muutamassa sekunnissa ja seuraa sen edistymistä.",
  "📂 Gestion des projets": "📂 Projektinhallinta",
  "Accédez à vos projets non attribués, en cours, en retard ou validés pour suivre leur progression.": "Pääsy osoittamattomiin, käynnissä oleviin, myöhässä oleviin tai valmiisiin projekteihin edistymisen seuraamiseksi.",
  "👤 Mon profil": "👤 Profiilini",
  "Modifiez vos informations personnelles.": "Muokkaa henkilötietojasi.",
  "🧑‍🤝‍🧑 Gestion des utilisateurs": "🧑‍🤝‍🧑 Käyttäjähallinta",
  "Invitez de nouveaux membres, gérez leurs droits et organisez vos équipes simplement.": "Kutsu uusia jäseniä, hallitse heidän oikeuksiaan ja organisoi tiimisi helposti.",
  "❓ Mon guide": "❓ Oppaani",
  "Relancez ce guide interactif à tout moment pour retrouver les principales fonctionnalités de Typix.": "Käynnistä tämä interaktiivinen opas uudelleen milloin tahansa päästäksesi Typixin tärkeimpiin toimintoihin.",
  'Mon guide': 'Oppaani',
  'Se déconnecter': 'Kirjaudu ulos',
  "L'adresse email est obligatoire.": "Sähköpostiosoite on pakollinen.",
  "Le nom est obligatoire.": "Sukunimi on pakollinen.",
  "Le prénom est obligatoire.": "Etunimi on pakollinen.",
  "Le mot de passe est obligatoire.": "Salasana on pakollinen.",
  "La confirmation est obligatoire.": "Vahvistus on pakollinen.",
  "Les mots de passe ne correspondent pas.": "Salasanat eivät täsmää.",
  "Récapitulatif": "Yhteenveto",
  "Quitter la création": "Poistu luonnoksesta",
  "Objectif du projet": "Projektin tavoite",
  "Mode de production": "Tuotantotapa",
  "Répartition du travail": "Työn jakaminen",
  "Contexte éditorial": "Toimituksellinen konteksti",
  "Rédaction": "Kirjoittaminen",
  "Traduction": "Käännös",
  "Créer du contenu original": "Luo alkuperäistä sisältöä",
  "Traduire un contenu existant": "Käännä olemassa oleva sisältö",
  "Identification du projet": "Projektin tunnistaminen",
  "Nom du projet": "Projektin nimi",
  "Vous pourrez modifier le nom plus tard": "Voit muuttaa nimen myöhemmin",
  "URL du site": "Sivuston URL",
  "Langue": "Kieli",
  "Sélectionner une langue": "Valitse kieli",
  "Nombre de textes": "Tekstien määrä",
  "12 textes disponibles": "12 saatavilla olevaa tekstiä",
  "Chef de projet": "Projektipäällikkö",
  "Aucun chef de projet assigné au siteweb": "Sivustoon ei ole määritetty projektipäällikköä",
  "Sélectionner un chef de projet": "Valitse projektipäällikkö",
  "Date limite du projet": "Projektin määräaika",
  "Sélectionner une date limite": "Valitse määräaika",
  "Retour": "Takaisin",
  "Définissez l'objectif et le cadre général de votre projet.": "Määritä projektisi tavoite ja yleinen viitekehys.",
  "IA": "AI",
  "Production généré par IA": "AI:n tuottama tuotanto",
  "Rédacteur": "Kirjoittaja",
  "Production Rédacteur par IA": "Kirjoittajan tuotanto AI:lla",
  "IA + revue humaine": "AI + ihmistarkastus",
  "IA avec validation humaine.": "AI ihmisen vahvistuksella.",
  "Répartissez les textes de votre projet entre vous et d'éventuels rédacteurs.": "Jaa projektisi tekstit itsesi ja mahdollisten kirjoittajien kesken.",
  "L'attribution à un rédacteur est optionnelle.": "Määritys kirjoittajalle on valinnainen.",
  "Agent IA": "AI-agentti",
  "Vous pourrez changer d'agent plus tard": "Voit vaihtaa agenttia myöhemmin",
  "Veuillez d'abord sélectionner un site web": "Valitse ensin sivusto",
  "Sélectionnez le mode IA": "Valitse AI-tila",
  "Aucun agent disponible": "Yhtään agenttia ei saatavilla",
  "Sélectionner un agent IA": "Valitse AI-agentti",
  "Format du contenu": "Sisällön muoto",
  "Sélectionner un format": "Valitse muoto",
  "Nombre de mots par texte": "Sanojen määrä tekstissä",
  "Format personnalisé": "Mukautettu muoto",
  "définir le nombre de mots": "määritä sanojen määrä",
  "mots": "sanaa",
  "Options avancées": "Lisäasetukset",
  "Enrichissement du contenu": "Sisällön rikastaminen",
  "Génération Image": "Kuvien Generointi",
  "Nombre d’images": "Kuvien Määrä",
  "Définir le nombre d’images": "Määritä kuvien määrä",
  "Consomment des crédits supplémentaires": "Kuluttavat lisäkredittejä",
  "IA augmentée par vos données": "AI, jota parannetaan tietojasi käyttäen",
  "Sélectionnez les personnes en charge de la relecture des contenus générés par l'IA et répartissez": "Valitse AI:n tuottaman sisällön tarkastuksesta vastaavat henkilöt ja jaa",
  "les textes à valider.": "vahvistettavat tekstit.",
  "Le relecteur peut apporter des corrections et ajustements ciblés dans la limite de mots définie,": "Tarkastaja voi tehdä korjauksia ja kohdennettuja muutoksia määritellyn sanamäärän rajoissa,",
  "sans réécrire entièrement le contenu.": "kirjoittamatta sisältöä kokonaan uudelleen.",
  "Contexte éditorial & brief détaillé du projet": "Toimituksellinen konteksti ja projektin yksityiskohtainen käsikirjoitus",
  "Ajouter des informations contextuelles pour guider et enrichir la production des contenus.": "Lisää kontekstuaalisia tietoja ohjaamaan ja rikastamaan sisällöntuotantoa.",
  "Gap sémantique": "Semanttinen kuilu",
  "optionnel": "valinnainen",
  "Brief détaillé": "Yksityiskohtainen käsikirjoitus",
  "Lien drive...": "Drive-linkki...",
  "Lancer le projet": "Käynnistä projekti",
  "Nom du projet existant": "Projektin nimi on jo olemassa",
  "Un projet avec ce nom existe déjà dans votre espace.": "Projekti tällä nimellä on jo olemassa tilallasi.",
  "Merci de choisir un nom différent pour continuer.": "Valitse eri nimi jatkaaksesi.",
  "Erreur lors de la création du projet. Veuillez réessayer.": "Virhe projektin luonnissa. Yritä uudelleen.",
  "Félicitations !": "Onnittelut!",
  "Votre projet a été créé avec succès !": "Projektisi on luotu onnistuneesti!",
  "Voir le projet": "Näytä projekti",
  "Fermer": "Sulje",
  "Paramètres du compte": "Tilin asetukset",
  "Site web": "Sivusto",
  "Langue du site": "Sivuston kieli",
  "textes": "tekstit",
  "Deadline": "Määräaika",
  "Type": "Tyyppi",
  "Rédacteur": "Kirjoittaja",
  "Moi (par défaut)": "Minä (oletus)",
  "Livraison le": "Toimitus",
  "À venir": "Tulossa",
  "Production généré par IA": "AI:n tuottama tuotanto",
  "Agent": "Agentti",
  "Format": "Muoto",
  "Enrichissement du contenu activé": "Sisällön rikastaminen käytössä",
  "Relecteur": "Tarkastaja",
  "texte": "teksti",
  "Limite de modification": "Muutosraja",
  "Aucune attribution": "Ei määritystä",
  "Aucun élément ajouté": "Yhtään elementtiä ei lisätty",
  "janvier": "tammikuu",
  "février": "helmikuu",
  "mars": "maaliskuu",
  "avril": "huhtikuu",
  "mai": "toukokuu",
  "juin": "kesäkuu",
  "juillet": "heinäkuu",
  "août": "elokuu",
  "septembre": "syyskuu",
  "octobre": "lokakuu",
  "novembre": "marraskuu",
  "décembre": "joulukuu",
  "à": "–",
  "mots minimum": "sanaa vähintään",
  "mots maximum": "sanaa enintään",
  "Status de validation des projets": "Projektien validointitila",
  "Statut d'avancement des contenus": "Sisällön edistymisen tila:",
  "Total des contenus": "Sisältö yhteensä:",
  "Non attribué": "Ei määritetty",
  "Évolution des performances": "Suorituskyvyn kehitys",
  "Position": "Sijoitus",
  "Nombre de textes publiés": "Julkaistujen tekstien määrä",
  "Espace de travail AI": "AI-työtila",
  "Mise à jour 1.2": "Päivitys 1.2",
  "Découvrez les dernières fonctionnalités, optimisations et correctifs.": "Tutustu uusimpiin ominaisuuksiin, optimointeihin ja korjauksiin.",
  "Projet créé": "Projekti luotu",
  "Votre projet a bien été créé.": "Projektisi on luotu onnistuneesti.",
  "Vous pouvez commencer à travailler dessus dès maintenant.": "Voit aloittaa työskentelyn siinä heti.",
  "Sélectionnez le mode IA": "Valitse AI-tila",
  "Aucun agent disponible": "Yhtään agenttia ei saatavilla",
  "Sélectionner un agent IA": "Valitse AI-agentti",
  "Sélectionner un format": "Valitse muoto",
  "Veuillez d'abord sélectionner un site web": "Valitse ensin sivusto",
  'Nouveau contenu': 'Uusi sisältö',
  'Génération en cours...': 'Generointi käynnissä...',
  'Optimisation en cours...': 'Optimointi käynnissä...',
  'Traduction en cours...': 'Käännös käynnissä...',
  'En lignes': 'Verkossa',
  'filtres': 'suodattimet',
  'trier par': 'lajittele',
  'Score décroissant': 'Laskeva pistemäärä',
  'Score croissant': 'Nouseva pistemäärä',
  'Date de création': 'Luontipäivä',
  'Date de mise à jour': 'Viimeisin päivitys',
  'Date récente': 'Uusin',
  'Date ancienne': 'Vanhin',
  'Mots clés': 'Avainsanat',
  'Éditeur': 'Muokkaaja',
  'Créateur': 'Luonut',
  'Rédacteurs': 'Kirjoittajat',
  'Réinitialisé par défaut': 'Palauta oletusasetukset',
  'Mode de rédaction': 'Kirjoitustila',
  'Agent AI utilisé': 'Käytetty AI-agentti',
  'Textes en brouillons': 'Luonnokset',
  'Modèle': 'Malli',
  'Paramètres du projet': 'Projektin asetukset',
  'Avancement': 'Tila',
  'Progression': 'Edistyminen',
  'Aucun texte disponible': 'Tekstiä ei saatavilla',
  'Détails du projet': 'Projektin tiedot',
  'Page {{current}} sur {{total}}': 'Sivu {{current}} / {{total}}',
  'Moteur LLM': 'LLM-moottori',
  'Rédiger un contenu': 'Kirjoita sisältöä',
  'Traduire un contenu': 'Käännä sisältöä',
  'Optimiser un contenu': 'Optimoi sisältöä',
  'Générer un contenu': 'Generoi sisältöä',

  'Créez un texte pour un mot-clé spécifique avec un formulaire guidé':
    'Luo teksti tietylle avainsanalle ohjatun lomakkeen avulla',

  'Traduire un texte spécifique avec un formulaire guidé':
    'Käännä tietty teksti ohjatun lomakkeen avulla',

  'Générez plusieurs textes en important un fichier Excel':
    'Generoi useita tekstejä tuomalla Excel-tiedosto',

  'Rédiger un lot de contenus': 'Kirjoita erä sisältöjä',
  'Traduire un lot de contenus': 'Käännä erä sisältöjä',
  'Enrichir un contenu': 'Rikasta sisältöä',

  'Optimisez un texte spécifique avec un formulaire guidé':
    'Optimoi tietty teksti ohjatun lomakkeen avulla',

  'Nombre total de textes alloués au projet':
    'Projektille varattujen tekstien kokonaismäärä',

  'Vous pourrez changer le format du contenu plus tard':
    'Voit muuttaa sisällön muotoa myöhemmin',

  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, puis appuyez sur Entrée. Exemple : chaussures(3)':
    'Syötä jokainen avainsana ja sen esiintymistiheys sulkeissa, ja paina sitten Enter. Esimerkki: kengät(3)',

  'Ex: voiture(5), électrique(3), autonomie(8)':
    'Esim.: auto(5), sähköinen(3), toimintasäde(8)',

  'URLs des pages à lier (séparées par des virgules)':
    'Linkitettävien sivujen URL-osoitteet (erotettu pilkuilla)',

  'Besoin d\'aide pour préparer votre fichier ?':
    'Tarvitsetko apua tiedoston valmistelussa?',

  'Télécharger le modèle (Excel)':
    'Lataa malli (Excel)',

  'Déposez votre fichier ici':
    'Pudota tiedostosi tähän',

  'Glissez-déposez votre fichier Excel':
    'Vedä ja pudota Excel-tiedostosi',

  'ou cliquez pour parcourir':
    'tai napsauta selataksesi',

  'Formats acceptés : .xlsx, .xls (max 10 Mo)':
    'Hyväksytyt muodot: .xlsx, .xls (enintään 10 Mt)',

  'Parcourir les fichiers':
    'Selaa tiedostoja',

  'Ex: télépéage automatique':
    'Esim.: automaattinen tiemaksu',

  'Générer le contenu': 'Generoi sisältö',
  'Lancer la génération': 'Käynnistä generointi',
  'Commencer la traduction': 'Aloita käännös',
  'Lancer la traduction': 'Käynnistä käännös',

  'Partager': 'Jaa',
  'Telecharger le texte': 'Lataa teksti',
  'Modifier le projet': 'Muokkaa projektia',
  'Modifiez les détails de votre projet ici.':
    'Muokkaa projektisi tietoja täällä.',

  'Général': 'Yleinen',
  'Allocation des textes': 'Tekstien jakaminen',
  'Sélectionner un format du contenu': 'Valitse sisällön muoto',
  'Allocation aux rédacteurs': 'Jakaminen kirjoittajille',

  '{{count}} textes disponibles':
    '{{count}} tekstiä saatavilla',

  'Sélectionner un rédacteur': 'Valitse kirjoittaja',
  'Nom du rédacteur': 'Kirjoittajan nimi',
  'Date limite': 'Määräaika',
  'texte restant': 'jäljellä oleva teksti',
  'textes alloués': 'varatut tekstit',

  'Article court - 300 mots': 'Lyhyt artikkeli – 300 sanaa',
  'Article moyen - 600 mots': 'Keskipitkä artikkeli – 600 sanaa',
  'Article long - 1000 words': 'Pitkä artikkeli – 1000 sanaa',
  'Youtube - 350 mots': 'YouTube – 350 sanaa',
  'Linkedin - 200 mots': 'LinkedIn – 200 sanaa',
  'X - 150 mots': 'X – 150 sanaa',
  'Personnalisé': 'Mukautettu',

'Voir plus': 'Näytä lisää',
' à votre ': ' sinun ',
'{{count}} textes à livrer':
'{{count}} toimitettavaa tekstiä',
'Nous contacter': 'Ota yhteyttä',
'Vous avez une question ou un problème ? Contactez-nous et nous vous répondrons dans les plus brefs délais.': 'Onko sinulla kysymys tai ongelma? Ota meihin yhteyttä, niin vastaamme mahdollisimman pian.',
'Sujet': 'Aihe',
'Message': 'Viesti',
'Soumettre ma demande': 'Lähetä pyyntöni',
'Veuillez sélectionner un sujet': 'Valitse aihe',
'Décrivez votre demande en détail...': 'Kuvaile pyyntöäsi yksityiskohtaisesti...',
'Sélectionnez un sujet': 'Valitse aihe',
'Autre': 'Muu',
'Feedback': 'Palaute',
'Question': 'Kysymys',
'Bug': 'Virhe',
'Le message doit contenir au moins 10 caractères': 'Viestin on sisällettävä vähintään 10 merkkiä',
'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.': 'Viestisi on lähetetty onnistuneesti. Vastaamme mahdollisimman pian.',
'Votre demande a bien été transmise à notre équipe support, qui vous répondra dans les plus brefs délais.': 'Pyyntösi on välitetty tukitiimillemme, joka vastaa sinulle mahdollisimman pian.',
'Envoi en cours...': 'Lähetetään...',
'Fermer': 'Sulje',
'Créer un nouvel agent AI': 'Luo uusi AI-agentti',
'Mission de l\'agent': 'Agentin tehtävä',
'L\'agent générera du contenu original à partir de vos consignes.': 'Agentti luo alkuperäistä sisältöä ohjeidesi perusteella.',
'Informations générales': 'Yleiset tiedot',
'Informations principales': 'Päätiedot',
'Ton & audience': 'Sävy ja kohdeyleisö',
'Structure & rédaction': 'Rakenne ja kirjoittaminen',
'Base de connaissances': 'Tietopohja',
'Construction du contenu': 'Sisällön rakentaminen',
'Structure attendu': 'Odotettu rakenne',
'Cadre lexical': 'Sanastollinen kehys',
'Personnalisation avancée': 'Edistynyt mukauttaminen',
'Base de connaissance locale en ligne': 'Verkossa oleva paikallinen tietopohja',
'Glissez-déposez votre fichier': 'Vedä ja pudota tiedostosi',
'Base de connaissance': 'Tietopohja',
'Indiquez la liste des urls sur lesquels l’IA peut s’appuyer': 'Anna luettelo URL-osoitteista, joihin AI voi tukeutua',
'Définissez le positionnement éditorial de votre agent afin qu’il adapte son ton,': 'Määritä agenttisi toimituksellinen linjaus, jotta se mukauttaa sävynsä,',
'sa cible et son vocabulaire à votre activité.': 'kohdeyleisönsä ja sanastonsa toimintaasi.',
'caractères': 'merkit',
};
